import Post_Text_Bg_Animal01_01_Th from '../../assets/graphics/png/collections/post_background/_thumbnails/post_text_bg_animal01_01_th.png';
import Post_Text_Bg_Animal02_01_Th from '../../assets/graphics/png/collections/post_background/_thumbnails/post_text_bg_animal02_01_th.png';
import Post_Text_Bg_Animal03_01_Th from '../../assets/graphics/png/collections/post_background/_thumbnails/post_text_bg_animal03_01_th.png';
import Post_Text_Bg_Animal04_01_Th from '../../assets/graphics/png/collections/post_background/_thumbnails/post_text_bg_animal04_01_th.png';
import Post_Text_Bg_Animal05_01_Th from '../../assets/graphics/png/collections/post_background/_thumbnails/post_text_bg_animal05_01_th.png';
import Post_Text_Bg_Animal06_01_Th from '../../assets/graphics/png/collections/post_background/_thumbnails/post_text_bg_animal06_01_th.png';
import Post_Text_Bg_Celebration01_01_Th from '../../assets/graphics/png/collections/post_background/_thumbnails/post_text_bg_celebration01_01_th.png';
import Post_Text_Bg_Celebration02_01_Th from '../../assets/graphics/png/collections/post_background/_thumbnails/post_text_bg_celebration02_01_th.png';
import Post_Text_Bg_Celebration03_01_Th from '../../assets/graphics/png/collections/post_background/_thumbnails/post_text_bg_celebration03_01_th.png';
import Post_Text_Bg_Celebration04_01_Th from '../../assets/graphics/png/collections/post_background/_thumbnails/post_text_bg_celebration04_01_th.png';
import Post_Text_Bg_Celebration05_01_Th from '../../assets/graphics/png/collections/post_background/_thumbnails/post_text_bg_celebration05_01_th.png';
import Post_Text_Bg_Celebration06_01_Th from '../../assets/graphics/png/collections/post_background/_thumbnails/post_text_bg_celebration06_01_th.png';
import Post_Text_Bg_Celebration07_01_Th from '../../assets/graphics/png/collections/post_background/_thumbnails/post_text_bg_celebration07_01_th.png';
import Post_Text_Bg_Celebration08_01_Th from '../../assets/graphics/png/collections/post_background/_thumbnails/post_text_bg_celebration08_01_th.png';
import Post_Text_Bg_Celebration09_01_Th from '../../assets/graphics/png/collections/post_background/_thumbnails/post_text_bg_celebration09_01_th.png';
import Post_Text_Bg_Celebration10_01_Th from '../../assets/graphics/png/collections/post_background/_thumbnails/post_text_bg_celebration10_01_th.png';
import Post_Text_Bg_Celebration11_01_Th from '../../assets/graphics/png/collections/post_background/_thumbnails/post_text_bg_celebration11_01_th.png';
import Post_Text_Bg_Color01_01_Th from '../../assets/graphics/png/collections/post_background/_thumbnails/post_text_bg_color01_01_th.png';
import Post_Text_Bg_Color02_01_Th from '../../assets/graphics/png/collections/post_background/_thumbnails/post_text_bg_color02_01_th.png';
import Post_Text_Bg_Color03_01_Th from '../../assets/graphics/png/collections/post_background/_thumbnails/post_text_bg_color03_01_th.png';
import Post_Text_Bg_Color04_01_Th from '../../assets/graphics/png/collections/post_background/_thumbnails/post_text_bg_color04_01_th.png';
import Post_Text_Bg_Color05_01_Th from '../../assets/graphics/png/collections/post_background/_thumbnails/post_text_bg_color05_01_th.png';
import Post_Text_Bg_Color06_01_Th from '../../assets/graphics/png/collections/post_background/_thumbnails/post_text_bg_color06_01_th.png';
import Post_Text_Bg_Color07_01_Th from '../../assets/graphics/png/collections/post_background/_thumbnails/post_text_bg_color07_01_th.png';
import Post_Text_Bg_Color08_01_Th from '../../assets/graphics/png/collections/post_background/_thumbnails/post_text_bg_color08_01_th.png';
import Post_Text_Bg_Color09_01_Th from '../../assets/graphics/png/collections/post_background/_thumbnails/post_text_bg_color09_01_th.png';
import Post_Text_Bg_Color10_01_Th from '../../assets/graphics/png/collections/post_background/_thumbnails/post_text_bg_color10_01_th.png';
import Post_Text_Bg_Color11_01_Th from '../../assets/graphics/png/collections/post_background/_thumbnails/post_text_bg_color11_01_th.png';
import Post_Text_Bg_Color12_01_Th from '../../assets/graphics/png/collections/post_background/_thumbnails/post_text_bg_color12_01_th.png';
import Post_Text_Bg_Fruit01_01_Th from '../../assets/graphics/png/collections/post_background/_thumbnails/post_text_bg_fruit01_01_th.png';
import Post_Text_Bg_Fruit02_01_Th from '../../assets/graphics/png/collections/post_background/_thumbnails/post_text_bg_fruit02_01_th.png';
import Post_Text_Bg_Fruit03_01_Th from '../../assets/graphics/png/collections/post_background/_thumbnails/post_text_bg_fruit03_01_th.png';
import Post_Text_Bg_Fruit04_01_Th from '../../assets/graphics/png/collections/post_background/_thumbnails/post_text_bg_fruit04_01_th.png';
import Post_Text_Bg_Fruit05_01_Th from '../../assets/graphics/png/collections/post_background/_thumbnails/post_text_bg_fruit05_01_th.png';
import Post_Text_Bg_Fruit06_01_Th from '../../assets/graphics/png/collections/post_background/_thumbnails/post_text_bg_fruit06_01_th.png';
import Post_Text_Bg_Fruit07_01_Th from '../../assets/graphics/png/collections/post_background/_thumbnails/post_text_bg_fruit07_01_th.png';
import Post_Text_Bg_Fruit08_01_Th from '../../assets/graphics/png/collections/post_background/_thumbnails/post_text_bg_fruit08_01_th.png';
import Post_Text_Bg_Funny01_01_Th from '../../assets/graphics/png/collections/post_background/_thumbnails/post_text_bg_funny01_01_th.png';
import Post_Text_Bg_Funny02_01_Th from '../../assets/graphics/png/collections/post_background/_thumbnails/post_text_bg_funny02_01_th.png';
import Post_Text_Bg_Funny03_01_Th from '../../assets/graphics/png/collections/post_background/_thumbnails/post_text_bg_funny03_01_th.png';
import Post_Text_Bg_Funny04_01_Th from '../../assets/graphics/png/collections/post_background/_thumbnails/post_text_bg_funny04_01_th.png';
import Post_Text_Bg_Funny05_01_Th from '../../assets/graphics/png/collections/post_background/_thumbnails/post_text_bg_funny05_01_th.png';
import Post_Text_Bg_Funny06_01_Th from '../../assets/graphics/png/collections/post_background/_thumbnails/post_text_bg_funny06_01_th.png';
import Post_Text_Bg_Gradient01_01_Th from '../../assets/graphics/png/collections/post_background/_thumbnails/post_text_bg_gradient01_01_th.png';
import Post_Text_Bg_Gradient02_01_Th from '../../assets/graphics/png/collections/post_background/_thumbnails/post_text_bg_gradient02_01_th.png';
import Post_Text_Bg_Gradient03_01_Th from '../../assets/graphics/png/collections/post_background/_thumbnails/post_text_bg_gradient03_01_th.png';
import Post_Text_Bg_Gradient04_01_Th from '../../assets/graphics/png/collections/post_background/_thumbnails/post_text_bg_gradient04_01_th.png';
import Post_Text_Bg_Gradient05_01_Th from '../../assets/graphics/png/collections/post_background/_thumbnails/post_text_bg_gradient05_01_th.png';
import Post_Text_Bg_Gradient06_01_Th from '../../assets/graphics/png/collections/post_background/_thumbnails/post_text_bg_gradient06_01_th.png';
import Post_Text_Bg_Gradient07_01_Th from '../../assets/graphics/png/collections/post_background/_thumbnails/post_text_bg_gradient07_01_th.png';
import Post_Text_Bg_Gradient08_01_Th from '../../assets/graphics/png/collections/post_background/_thumbnails/post_text_bg_gradient08_01_th.png';
import Post_Text_Bg_Gradient09_01_Th from '../../assets/graphics/png/collections/post_background/_thumbnails/post_text_bg_gradient09_01_th.png';
import Post_Text_Bg_Gradient10_01_Th from '../../assets/graphics/png/collections/post_background/_thumbnails/post_text_bg_gradient10_01_th.png';
import Post_Text_Bg_Gradient11_01_Th from '../../assets/graphics/png/collections/post_background/_thumbnails/post_text_bg_gradient11_01_th.png';
import Post_Text_Bg_Gradient12_01_Th from '../../assets/graphics/png/collections/post_background/_thumbnails/post_text_bg_gradient12_01_th.png';
import Post_Text_Bg_Gradient13_01_Th from '../../assets/graphics/png/collections/post_background/_thumbnails/post_text_bg_gradient13_01_th.png';
import Post_Text_Bg_Gradient14_01_Th from '../../assets/graphics/png/collections/post_background/_thumbnails/post_text_bg_gradient14_01_th.png';
import Post_Text_Bg_Gradient15_01_Th from '../../assets/graphics/png/collections/post_background/_thumbnails/post_text_bg_gradient15_01_th.png';
import Post_Text_Bg_Gradient16_01_Th from '../../assets/graphics/png/collections/post_background/_thumbnails/post_text_bg_gradient16_01_th.png';
import Post_Text_Bg_Pattern01_01_Th from '../../assets/graphics/png/collections/post_background/_thumbnails/post_text_bg_pattern01_01_th.png';
import Post_Text_Bg_Pattern02_01_Th from '../../assets/graphics/png/collections/post_background/_thumbnails/post_text_bg_pattern02_01_th.png';
import Post_Text_Bg_Pattern03_01_Th from '../../assets/graphics/png/collections/post_background/_thumbnails/post_text_bg_pattern03_01_th.png';
import Post_Text_Bg_Pattern04_01_Th from '../../assets/graphics/png/collections/post_background/_thumbnails/post_text_bg_pattern04_01_th.png';
import Post_Text_Bg_Pattern05_01_Th from '../../assets/graphics/png/collections/post_background/_thumbnails/post_text_bg_pattern05_01_th.png';
import Post_Text_Bg_Pattern06_01_Th from '../../assets/graphics/png/collections/post_background/_thumbnails/post_text_bg_pattern06_01_th.png';
import Post_Text_Bg_Pattern07_01_Th from '../../assets/graphics/png/collections/post_background/_thumbnails/post_text_bg_pattern07_01_th.png';
import Post_Text_Bg_Pattern08_01_Th from '../../assets/graphics/png/collections/post_background/_thumbnails/post_text_bg_pattern08_01_th.png';
import Post_Text_Bg_Pattern09_01_Th from '../../assets/graphics/png/collections/post_background/_thumbnails/post_text_bg_pattern09_01_th.png';
import Post_Text_Bg_Pattern10_01_Th from '../../assets/graphics/png/collections/post_background/_thumbnails/post_text_bg_pattern10_01_th.png';
import Post_Text_Bg_Pattern11_01_Th from '../../assets/graphics/png/collections/post_background/_thumbnails/post_text_bg_pattern11_01_th.png';
import Post_Text_Bg_Pattern12_01_Th from '../../assets/graphics/png/collections/post_background/_thumbnails/post_text_bg_pattern12_01_th.png';
import Post_Text_Bg_Pattern13_01_Th from '../../assets/graphics/png/collections/post_background/_thumbnails/post_text_bg_pattern13_01_th.png';
import Post_Text_Bg_Pattern14_01_Th from '../../assets/graphics/png/collections/post_background/_thumbnails/post_text_bg_pattern14_01_th.png';
import Post_Text_Bg_Plant01_01_Th from '../../assets/graphics/png/collections/post_background/_thumbnails/post_text_bg_plant01_01_th.png';
import Post_Text_Bg_Plant02_01_Th from '../../assets/graphics/png/collections/post_background/_thumbnails/post_text_bg_plant02_01_th.png';
import Post_Text_Bg_Plant03_01_Th from '../../assets/graphics/png/collections/post_background/_thumbnails/post_text_bg_plant03_01_th.png';
import Post_Text_Bg_Plant04_01_Th from '../../assets/graphics/png/collections/post_background/_thumbnails/post_text_bg_plant04_01_th.png';
import Post_Text_Bg_Plant05_01_Th from '../../assets/graphics/png/collections/post_background/_thumbnails/post_text_bg_plant05_01_th.png';
import Post_Text_Bg_Plant06_01_Th from '../../assets/graphics/png/collections/post_background/_thumbnails/post_text_bg_plant06_01_th.png';
import Post_Text_Bg_Season01_01_Th from '../../assets/graphics/png/collections/post_background/_thumbnails/post_text_bg_season01_01_th.png';
import Post_Text_Bg_Season02_01_Th from '../../assets/graphics/png/collections/post_background/_thumbnails/post_text_bg_season02_01_th.png';
import Post_Text_Bg_Season03_01_Th from '../../assets/graphics/png/collections/post_background/_thumbnails/post_text_bg_season03_01_th.png';
import Post_Text_Bg_Season04_01_Th from '../../assets/graphics/png/collections/post_background/_thumbnails/post_text_bg_season04_01_th.png';
import Post_Text_Bg_Texture01_01_Th from '../../assets/graphics/png/collections/post_background/_thumbnails/post_text_bg_texture01_01_th.png';
import Post_Text_Bg_Texture02_01_Th from '../../assets/graphics/png/collections/post_background/_thumbnails/post_text_bg_texture02_01_th.png';
import Post_Text_Bg_Texture03_01_Th from '../../assets/graphics/png/collections/post_background/_thumbnails/post_text_bg_texture03_01_th.png';
import Post_Text_Bg_Texture04_01_Th from '../../assets/graphics/png/collections/post_background/_thumbnails/post_text_bg_texture04_01_th.png';
import Post_Text_Bg_Texture05_01_Th from '../../assets/graphics/png/collections/post_background/_thumbnails/post_text_bg_texture05_01_th.png';
import Post_Text_Bg_Texture06_01_Th from '../../assets/graphics/png/collections/post_background/_thumbnails/post_text_bg_texture06_01_th.png';
import Post_Text_Bg_Texture07_01_Th from '../../assets/graphics/png/collections/post_background/_thumbnails/post_text_bg_texture07_01_th.png';
import Post_Text_Bg_Texture08_01_Th from '../../assets/graphics/png/collections/post_background/_thumbnails/post_text_bg_texture08_01_th.png';
import Post_Text_Bg_Texture09_01_Th from '../../assets/graphics/png/collections/post_background/_thumbnails/post_text_bg_texture09_01_th.png';
import Post_Text_Bg_Texture10_01_Th from '../../assets/graphics/png/collections/post_background/_thumbnails/post_text_bg_texture10_01_th.png';
import Post_Text_Bg_Weather01_01_Th from '../../assets/graphics/png/collections/post_background/_thumbnails/post_text_bg_weather01_01_th.png';
import Post_Text_Bg_Weather02_01_Th from '../../assets/graphics/png/collections/post_background/_thumbnails/post_text_bg_weather02_01_th.png';
import Post_Text_Bg_Weather03_01_Th from '../../assets/graphics/png/collections/post_background/_thumbnails/post_text_bg_weather03_01_th.png';
import Post_Text_Bg_Weather04_01_Th from '../../assets/graphics/png/collections/post_background/_thumbnails/post_text_bg_weather04_01_th.png';
import Post_Text_Bg_Weather05_01_Th from '../../assets/graphics/png/collections/post_background/_thumbnails/post_text_bg_weather05_01_th.png';
import Post_Text_Bg_Weather06_01_Th from '../../assets/graphics/png/collections/post_background/_thumbnails/post_text_bg_weather06_01_th.png';
import Post_Text_Bg_Weather07_01_Th from '../../assets/graphics/png/collections/post_background/_thumbnails/post_text_bg_weather07_01_th.png';
import Post_Text_Bg_Weather08_01_Th from '../../assets/graphics/png/collections/post_background/_thumbnails/post_text_bg_weather08_01_th.png';
import Post_Text_Bg_Weather09_01_Th from '../../assets/graphics/png/collections/post_background/_thumbnails/post_text_bg_weather09_01_th.png';
import Post_Text_Bg_Weather10_01_Th from '../../assets/graphics/png/collections/post_background/_thumbnails/post_text_bg_weather10_01_th.png';
import Post_Text_Bg_Weather11_01_Th from '../../assets/graphics/png/collections/post_background/_thumbnails/post_text_bg_weather11_01_th.png';
import Post_Text_Bg_Animal01_01 from '../../assets/graphics/png/collections/post_background/Animal/post_text_bg_animal01_01.png';
import Post_Text_Bg_Animal01_02 from '../../assets/graphics/png/collections/post_background/Animal/post_text_bg_animal01_02.png';
import Post_Text_Bg_Animal01_03 from '../../assets/graphics/png/collections/post_background/Animal/post_text_bg_animal01_03.png';
import Post_Text_Bg_Animal01_04 from '../../assets/graphics/png/collections/post_background/Animal/post_text_bg_animal01_04.png';
import Post_Text_Bg_Animal01_05 from '../../assets/graphics/png/collections/post_background/Animal/post_text_bg_animal01_05.png';
import Post_Text_Bg_Animal02_01 from '../../assets/graphics/png/collections/post_background/Animal/post_text_bg_animal02_01.png';
import Post_Text_Bg_Animal02_02 from '../../assets/graphics/png/collections/post_background/Animal/post_text_bg_animal02_02.png';
import Post_Text_Bg_Animal02_03 from '../../assets/graphics/png/collections/post_background/Animal/post_text_bg_animal02_03.png';
import Post_Text_Bg_Animal02_04 from '../../assets/graphics/png/collections/post_background/Animal/post_text_bg_animal02_04.png';
import Post_Text_Bg_Animal03_01 from '../../assets/graphics/png/collections/post_background/Animal/post_text_bg_animal03_01.png';
import Post_Text_Bg_Animal03_02 from '../../assets/graphics/png/collections/post_background/Animal/post_text_bg_animal03_02.png';
import Post_Text_Bg_Animal03_03 from '../../assets/graphics/png/collections/post_background/Animal/post_text_bg_animal03_03.png';
import Post_Text_Bg_Animal04_01 from '../../assets/graphics/png/collections/post_background/Animal/post_text_bg_animal04_01.png';
import Post_Text_Bg_Animal05_01 from '../../assets/graphics/png/collections/post_background/Animal/post_text_bg_animal05_01.png';
import Post_Text_Bg_Animal05_02 from '../../assets/graphics/png/collections/post_background/Animal/post_text_bg_animal05_02.png';
import Post_Text_Bg_Animal05_03 from '../../assets/graphics/png/collections/post_background/Animal/post_text_bg_animal05_03.png';
import Post_Text_Bg_Animal05_04 from '../../assets/graphics/png/collections/post_background/Animal/post_text_bg_animal05_04.png';
import Post_Text_Bg_Animal06_01 from '../../assets/graphics/png/collections/post_background/Animal/post_text_bg_animal06_01.png';
import Post_Text_Bg_Celebration01_01 from '../../assets/graphics/png/collections/post_background/Celebration/post_text_bg_celebration01_01.png';
import Post_Text_Bg_Celebration01_02 from '../../assets/graphics/png/collections/post_background/Celebration/post_text_bg_celebration01_02.png';
import Post_Text_Bg_Celebration01_03 from '../../assets/graphics/png/collections/post_background/Celebration/post_text_bg_celebration01_03.png';
import Post_Text_Bg_Celebration02_01 from '../../assets/graphics/png/collections/post_background/Celebration/post_text_bg_celebration02_01.png';
import Post_Text_Bg_Celebration02_02 from '../../assets/graphics/png/collections/post_background/Celebration/post_text_bg_celebration02_02.png';
import Post_Text_Bg_Celebration03_01 from '../../assets/graphics/png/collections/post_background/Celebration/post_text_bg_celebration03_01.png';
import Post_Text_Bg_Celebration03_02 from '../../assets/graphics/png/collections/post_background/Celebration/post_text_bg_celebration03_02.png';
import Post_Text_Bg_Celebration03_03 from '../../assets/graphics/png/collections/post_background/Celebration/post_text_bg_celebration03_03.png';
import Post_Text_Bg_Celebration03_04 from '../../assets/graphics/png/collections/post_background/Celebration/post_text_bg_celebration03_04.png';
import Post_Text_Bg_Celebration04_01 from '../../assets/graphics/png/collections/post_background/Celebration/post_text_bg_celebration04_01.png';
import Post_Text_Bg_Celebration04_02 from '../../assets/graphics/png/collections/post_background/Celebration/post_text_bg_celebration04_02.png';
import Post_Text_Bg_Celebration05_01 from '../../assets/graphics/png/collections/post_background/Celebration/post_text_bg_celebration05_01.png';
import Post_Text_Bg_Celebration05_02 from '../../assets/graphics/png/collections/post_background/Celebration/post_text_bg_celebration05_02.png';
import Post_Text_Bg_Celebration05_03 from '../../assets/graphics/png/collections/post_background/Celebration/post_text_bg_celebration05_03.png';
import Post_Text_Bg_Celebration05_04 from '../../assets/graphics/png/collections/post_background/Celebration/post_text_bg_celebration05_04.png';
import Post_Text_Bg_Celebration06_01 from '../../assets/graphics/png/collections/post_background/Celebration/post_text_bg_celebration06_01.png';
import Post_Text_Bg_Celebration06_02 from '../../assets/graphics/png/collections/post_background/Celebration/post_text_bg_celebration06_02.png';
import Post_Text_Bg_Celebration06_03 from '../../assets/graphics/png/collections/post_background/Celebration/post_text_bg_celebration06_03.png';
import Post_Text_Bg_Celebration07_01 from '../../assets/graphics/png/collections/post_background/Celebration/post_text_bg_celebration07_01.png';
import Post_Text_Bg_Celebration07_02 from '../../assets/graphics/png/collections/post_background/Celebration/post_text_bg_celebration07_02.png';
import Post_Text_Bg_Celebration07_03 from '../../assets/graphics/png/collections/post_background/Celebration/post_text_bg_celebration07_03.png';
import Post_Text_Bg_Celebration08_01 from '../../assets/graphics/png/collections/post_background/Celebration/post_text_bg_celebration08_01.png';
import Post_Text_Bg_Celebration08_02 from '../../assets/graphics/png/collections/post_background/Celebration/post_text_bg_celebration08_02.png';
import Post_Text_Bg_Celebration08_03 from '../../assets/graphics/png/collections/post_background/Celebration/post_text_bg_celebration08_03.png';
import Post_Text_Bg_Celebration09_01 from '../../assets/graphics/png/collections/post_background/Celebration/post_text_bg_celebration09_01.png';
import Post_Text_Bg_Celebration09_02 from '../../assets/graphics/png/collections/post_background/Celebration/post_text_bg_celebration09_02.png';
import Post_Text_Bg_Celebration09_03 from '../../assets/graphics/png/collections/post_background/Celebration/post_text_bg_celebration09_03.png';
import Post_Text_Bg_Celebration09_04 from '../../assets/graphics/png/collections/post_background/Celebration/post_text_bg_celebration09_04.png';
import Post_Text_Bg_Celebration10_01 from '../../assets/graphics/png/collections/post_background/Celebration/post_text_bg_celebration10_01.png';
import Post_Text_Bg_Celebration10_02 from '../../assets/graphics/png/collections/post_background/Celebration/post_text_bg_celebration10_02.png';
import Post_Text_Bg_Celebration10_03 from '../../assets/graphics/png/collections/post_background/Celebration/post_text_bg_celebration10_03.png';
import Post_Text_Bg_Celebration11_01 from '../../assets/graphics/png/collections/post_background/Celebration/post_text_bg_celebration11_01.png';
import Post_Text_Bg_Celebration11_02 from '../../assets/graphics/png/collections/post_background/Celebration/post_text_bg_celebration11_02.png';
import Post_Text_Bg_Celebration11_03 from '../../assets/graphics/png/collections/post_background/Celebration/post_text_bg_celebration11_03.png';
import Post_Text_Bg_Celebration11_04 from '../../assets/graphics/png/collections/post_background/Celebration/post_text_bg_celebration11_04.png';
import Post_Text_Bg_Color01_01 from '../../assets/graphics/png/collections/post_background/Color/post_text_bg_color01_01.png';
import Post_Text_Bg_Color02_01 from '../../assets/graphics/png/collections/post_background/Color/post_text_bg_color02_01.png';
import Post_Text_Bg_Color03_01 from '../../assets/graphics/png/collections/post_background/Color/post_text_bg_color03_01.png';
import Post_Text_Bg_Color04_01 from '../../assets/graphics/png/collections/post_background/Color/post_text_bg_color04_01.png';
import Post_Text_Bg_Color05_01 from '../../assets/graphics/png/collections/post_background/Color/post_text_bg_color05_01.png';
import Post_Text_Bg_Color06_01 from '../../assets/graphics/png/collections/post_background/Color/post_text_bg_color06_01.png';
import Post_Text_Bg_Color07_01 from '../../assets/graphics/png/collections/post_background/Color/post_text_bg_color07_01.png';
import Post_Text_Bg_Color08_01 from '../../assets/graphics/png/collections/post_background/Color/post_text_bg_color08_01.png';
import Post_Text_Bg_Color09_01 from '../../assets/graphics/png/collections/post_background/Color/post_text_bg_color09_01.png';
import Post_Text_Bg_Color10_01 from '../../assets/graphics/png/collections/post_background/Color/post_text_bg_color10_01.png';
import Post_Text_Bg_Color11_01 from '../../assets/graphics/png/collections/post_background/Color/post_text_bg_color11_01.png';
import Post_Text_Bg_Color12_01 from '../../assets/graphics/png/collections/post_background/Color/post_text_bg_color12_01.png';
import Post_Text_Bg_Fruit01_01 from '../../assets/graphics/png/collections/post_background/Fruit/post_text_bg_fruit01_01.png';
import Post_Text_Bg_Fruit01_02 from '../../assets/graphics/png/collections/post_background/Fruit/post_text_bg_fruit01_02.png';
import Post_Text_Bg_Fruit01_03 from '../../assets/graphics/png/collections/post_background/Fruit/post_text_bg_fruit01_03.png';
import Post_Text_Bg_Fruit01_04 from '../../assets/graphics/png/collections/post_background/Fruit/post_text_bg_fruit01_04.png';
import Post_Text_Bg_Fruit02_01 from '../../assets/graphics/png/collections/post_background/Fruit/post_text_bg_fruit02_01.png';
import Post_Text_Bg_Fruit02_02 from '../../assets/graphics/png/collections/post_background/Fruit/post_text_bg_fruit02_02.png';
import Post_Text_Bg_Fruit02_03 from '../../assets/graphics/png/collections/post_background/Fruit/post_text_bg_fruit02_03.png';
import Post_Text_Bg_Fruit02_04 from '../../assets/graphics/png/collections/post_background/Fruit/post_text_bg_fruit02_04.png';
import Post_Text_Bg_Fruit03_01 from '../../assets/graphics/png/collections/post_background/Fruit/post_text_bg_fruit03_01.png';
import Post_Text_Bg_Fruit03_02 from '../../assets/graphics/png/collections/post_background/Fruit/post_text_bg_fruit03_02.png';
import Post_Text_Bg_Fruit03_03 from '../../assets/graphics/png/collections/post_background/Fruit/post_text_bg_fruit03_03.png';
import Post_Text_Bg_Fruit03_04 from '../../assets/graphics/png/collections/post_background/Fruit/post_text_bg_fruit03_04.png';
import Post_Text_Bg_Fruit04_01 from '../../assets/graphics/png/collections/post_background/Fruit/post_text_bg_fruit04_01.png';
import Post_Text_Bg_Fruit04_02 from '../../assets/graphics/png/collections/post_background/Fruit/post_text_bg_fruit04_02.png';
import Post_Text_Bg_Fruit04_03 from '../../assets/graphics/png/collections/post_background/Fruit/post_text_bg_fruit04_03.png';
import Post_Text_Bg_Fruit04_04 from '../../assets/graphics/png/collections/post_background/Fruit/post_text_bg_fruit04_04.png';
import Post_Text_Bg_Fruit05_01 from '../../assets/graphics/png/collections/post_background/Fruit/post_text_bg_fruit05_01.png';
import Post_Text_Bg_Fruit05_02 from '../../assets/graphics/png/collections/post_background/Fruit/post_text_bg_fruit05_02.png';
import Post_Text_Bg_Fruit05_03 from '../../assets/graphics/png/collections/post_background/Fruit/post_text_bg_fruit05_03.png';
import Post_Text_Bg_Fruit05_04 from '../../assets/graphics/png/collections/post_background/Fruit/post_text_bg_fruit05_04.png';
import Post_Text_Bg_Fruit06_01 from '../../assets/graphics/png/collections/post_background/Fruit/post_text_bg_fruit06_01.png';
import Post_Text_Bg_Fruit06_02 from '../../assets/graphics/png/collections/post_background/Fruit/post_text_bg_fruit06_02.png';
import Post_Text_Bg_Fruit06_03 from '../../assets/graphics/png/collections/post_background/Fruit/post_text_bg_fruit06_03.png';
import Post_Text_Bg_Fruit06_04 from '../../assets/graphics/png/collections/post_background/Fruit/post_text_bg_fruit06_04.png';
import Post_Text_Bg_Fruit07_01 from '../../assets/graphics/png/collections/post_background/Fruit/post_text_bg_fruit07_01.png';
import Post_Text_Bg_Fruit07_02 from '../../assets/graphics/png/collections/post_background/Fruit/post_text_bg_fruit07_02.png';
import Post_Text_Bg_Fruit07_03 from '../../assets/graphics/png/collections/post_background/Fruit/post_text_bg_fruit07_03.png';
import Post_Text_Bg_Fruit08_01 from '../../assets/graphics/png/collections/post_background/Fruit/post_text_bg_fruit08_01.png';
import Post_Text_Bg_Fruit08_02 from '../../assets/graphics/png/collections/post_background/Fruit/post_text_bg_fruit08_02.png';
import Post_Text_Bg_Fruit08_03 from '../../assets/graphics/png/collections/post_background/Fruit/post_text_bg_fruit08_03.png';
import Post_Text_Bg_Fruit08_04 from '../../assets/graphics/png/collections/post_background/Fruit/post_text_bg_fruit08_04.png';
import Post_Text_Bg_Funny01_01 from '../../assets/graphics/png/collections/post_background/Funny/post_text_bg_funny01_01.png';
import Post_Text_Bg_Funny01_02 from '../../assets/graphics/png/collections/post_background/Funny/post_text_bg_funny01_02.png';
import Post_Text_Bg_Funny01_03 from '../../assets/graphics/png/collections/post_background/Funny/post_text_bg_funny01_03.png';
import Post_Text_Bg_Funny01_04 from '../../assets/graphics/png/collections/post_background/Funny/post_text_bg_funny01_04.png';
import Post_Text_Bg_Funny01_05 from '../../assets/graphics/png/collections/post_background/Funny/post_text_bg_funny01_05.png';
import Post_Text_Bg_Funny02_01 from '../../assets/graphics/png/collections/post_background/Funny/post_text_bg_funny02_01.png';
import Post_Text_Bg_Funny02_02 from '../../assets/graphics/png/collections/post_background/Funny/post_text_bg_funny02_02.png';
import Post_Text_Bg_Funny02_03 from '../../assets/graphics/png/collections/post_background/Funny/post_text_bg_funny02_03.png';
import Post_Text_Bg_Funny02_04 from '../../assets/graphics/png/collections/post_background/Funny/post_text_bg_funny02_04.png';
import Post_Text_Bg_Funny03_01 from '../../assets/graphics/png/collections/post_background/Funny/post_text_bg_funny03_01.png';
import Post_Text_Bg_Funny03_02 from '../../assets/graphics/png/collections/post_background/Funny/post_text_bg_funny03_02.png';
import Post_Text_Bg_Funny03_03 from '../../assets/graphics/png/collections/post_background/Funny/post_text_bg_funny03_03.png';
import Post_Text_Bg_Funny03_04 from '../../assets/graphics/png/collections/post_background/Funny/post_text_bg_funny03_04.png';
import Post_Text_Bg_Funny04_01 from '../../assets/graphics/png/collections/post_background/Funny/post_text_bg_funny04_01.png';
import Post_Text_Bg_Funny04_02 from '../../assets/graphics/png/collections/post_background/Funny/post_text_bg_funny04_02.png';
import Post_Text_Bg_Funny05_01 from '../../assets/graphics/png/collections/post_background/Funny/post_text_bg_funny05_01.png';
import Post_Text_Bg_Funny05_02 from '../../assets/graphics/png/collections/post_background/Funny/post_text_bg_funny05_02.png';
import Post_Text_Bg_Funny05_03 from '../../assets/graphics/png/collections/post_background/Funny/post_text_bg_funny05_03.png';
import Post_Text_Bg_Funny05_04 from '../../assets/graphics/png/collections/post_background/Funny/post_text_bg_funny05_04.png';
import Post_Text_Bg_Funny06_01 from '../../assets/graphics/png/collections/post_background/Funny/post_text_bg_funny06_01.png';
import Post_Text_Bg_Funny06_02 from '../../assets/graphics/png/collections/post_background/Funny/post_text_bg_funny06_02.png';
import Post_Text_Bg_Funny06_03 from '../../assets/graphics/png/collections/post_background/Funny/post_text_bg_funny06_03.png';
import Post_Text_Bg_Funny06_04 from '../../assets/graphics/png/collections/post_background/Funny/post_text_bg_funny06_04.png';
import Post_Text_Bg_Gradient01_01 from '../../assets/graphics/png/collections/post_background/Gradient/post_text_bg_gradient01_01.png';
import Post_Text_Bg_Gradient02_01 from '../../assets/graphics/png/collections/post_background/Gradient/post_text_bg_gradient02_01.png';
import Post_Text_Bg_Gradient03_01 from '../../assets/graphics/png/collections/post_background/Gradient/post_text_bg_gradient03_01.png';
import Post_Text_Bg_Gradient04_01 from '../../assets/graphics/png/collections/post_background/Gradient/post_text_bg_gradient04_01.png';
import Post_Text_Bg_Gradient05_01 from '../../assets/graphics/png/collections/post_background/Gradient/post_text_bg_gradient05_01.png';
import Post_Text_Bg_Gradient06_01 from '../../assets/graphics/png/collections/post_background/Gradient/post_text_bg_gradient06_01.png';
import Post_Text_Bg_Gradient07_01 from '../../assets/graphics/png/collections/post_background/Gradient/post_text_bg_gradient07_01.png';
import Post_Text_Bg_Gradient08_01 from '../../assets/graphics/png/collections/post_background/Gradient/post_text_bg_gradient08_01.png';
import Post_Text_Bg_Gradient09_01 from '../../assets/graphics/png/collections/post_background/Gradient/post_text_bg_gradient09_01.png';
import Post_Text_Bg_Gradient10_01 from '../../assets/graphics/png/collections/post_background/Gradient/post_text_bg_gradient10_01.png';
import Post_Text_Bg_Gradient11_01 from '../../assets/graphics/png/collections/post_background/Gradient/post_text_bg_gradient11_01.png';
import Post_Text_Bg_Gradient12_01 from '../../assets/graphics/png/collections/post_background/Gradient/post_text_bg_gradient12_01.png';
import Post_Text_Bg_Gradient13_01 from '../../assets/graphics/png/collections/post_background/Gradient/post_text_bg_gradient13_01.png';
import Post_Text_Bg_Gradient14_01 from '../../assets/graphics/png/collections/post_background/Gradient/post_text_bg_gradient14_01.png';
import Post_Text_Bg_Gradient15_01 from '../../assets/graphics/png/collections/post_background/Gradient/post_text_bg_gradient15_01.png';
import Post_Text_Bg_Gradient16_01 from '../../assets/graphics/png/collections/post_background/Gradient/post_text_bg_gradient16_01.png';
import Post_Text_Bg_Pattern01_01 from '../../assets/graphics/png/collections/post_background/Pattern/post_text_bg_pattern01_01.png';
import Post_Text_Bg_Pattern01_02 from '../../assets/graphics/png/collections/post_background/Pattern/post_text_bg_pattern01_02.png';
import Post_Text_Bg_Pattern01_03 from '../../assets/graphics/png/collections/post_background/Pattern/post_text_bg_pattern01_03.png';
import Post_Text_Bg_Pattern02_01 from '../../assets/graphics/png/collections/post_background/Pattern/post_text_bg_pattern02_01.png';
import Post_Text_Bg_Pattern02_02 from '../../assets/graphics/png/collections/post_background/Pattern/post_text_bg_pattern02_02.png';
import Post_Text_Bg_Pattern02_03 from '../../assets/graphics/png/collections/post_background/Pattern/post_text_bg_pattern02_03.png';
import Post_Text_Bg_Pattern02_04 from '../../assets/graphics/png/collections/post_background/Pattern/post_text_bg_pattern02_04.png';
import Post_Text_Bg_Pattern03_01 from '../../assets/graphics/png/collections/post_background/Pattern/post_text_bg_pattern03_01.png';
import Post_Text_Bg_Pattern03_02 from '../../assets/graphics/png/collections/post_background/Pattern/post_text_bg_pattern03_02.png';
import Post_Text_Bg_Pattern03_03 from '../../assets/graphics/png/collections/post_background/Pattern/post_text_bg_pattern03_03.png';
import Post_Text_Bg_Pattern04_01 from '../../assets/graphics/png/collections/post_background/Pattern/post_text_bg_pattern04_01.png';
import Post_Text_Bg_Pattern04_02 from '../../assets/graphics/png/collections/post_background/Pattern/post_text_bg_pattern04_02.png';
import Post_Text_Bg_Pattern04_03 from '../../assets/graphics/png/collections/post_background/Pattern/post_text_bg_pattern04_03.png';
import Post_Text_Bg_Pattern05_01 from '../../assets/graphics/png/collections/post_background/Pattern/post_text_bg_pattern05_01.png';
import Post_Text_Bg_Pattern05_02 from '../../assets/graphics/png/collections/post_background/Pattern/post_text_bg_pattern05_02.png';
import Post_Text_Bg_Pattern05_03 from '../../assets/graphics/png/collections/post_background/Pattern/post_text_bg_pattern05_03.png';
import Post_Text_Bg_Pattern05_04 from '../../assets/graphics/png/collections/post_background/Pattern/post_text_bg_pattern05_04.png';
import Post_Text_Bg_Pattern05_05 from '../../assets/graphics/png/collections/post_background/Pattern/post_text_bg_pattern05_05.png';
import Post_Text_Bg_Pattern05_06 from '../../assets/graphics/png/collections/post_background/Pattern/post_text_bg_pattern05_06.png';
import Post_Text_Bg_Pattern06_01 from '../../assets/graphics/png/collections/post_background/Pattern/post_text_bg_pattern06_01.png';
import Post_Text_Bg_Pattern06_02 from '../../assets/graphics/png/collections/post_background/Pattern/post_text_bg_pattern06_02.png';
import Post_Text_Bg_Pattern06_03 from '../../assets/graphics/png/collections/post_background/Pattern/post_text_bg_pattern06_03.png';
import Post_Text_Bg_Pattern06_04 from '../../assets/graphics/png/collections/post_background/Pattern/post_text_bg_pattern06_04.png';
import Post_Text_Bg_Pattern07_01 from '../../assets/graphics/png/collections/post_background/Pattern/post_text_bg_pattern07_01.png';
import Post_Text_Bg_Pattern08_01 from '../../assets/graphics/png/collections/post_background/Pattern/post_text_bg_pattern08_01.png';
import Post_Text_Bg_Pattern08_02 from '../../assets/graphics/png/collections/post_background/Pattern/post_text_bg_pattern08_02.png';
import Post_Text_Bg_Pattern08_03 from '../../assets/graphics/png/collections/post_background/Pattern/post_text_bg_pattern08_03.png';
import Post_Text_Bg_Pattern08_04 from '../../assets/graphics/png/collections/post_background/Pattern/post_text_bg_pattern08_04.png';
import Post_Text_Bg_Pattern09_01 from '../../assets/graphics/png/collections/post_background/Pattern/post_text_bg_pattern09_01.png';
import Post_Text_Bg_Pattern09_02 from '../../assets/graphics/png/collections/post_background/Pattern/post_text_bg_pattern09_02.png';
import Post_Text_Bg_Pattern10_01 from '../../assets/graphics/png/collections/post_background/Pattern/post_text_bg_pattern10_01.png';
import Post_Text_Bg_Pattern10_02 from '../../assets/graphics/png/collections/post_background/Pattern/post_text_bg_pattern10_02.png';
import Post_Text_Bg_Pattern10_03 from '../../assets/graphics/png/collections/post_background/Pattern/post_text_bg_pattern10_03.png';
import Post_Text_Bg_Pattern10_04 from '../../assets/graphics/png/collections/post_background/Pattern/post_text_bg_pattern10_04.png';
import Post_Text_Bg_Pattern10_05 from '../../assets/graphics/png/collections/post_background/Pattern/post_text_bg_pattern10_05.png';
import Post_Text_Bg_Pattern11_01 from '../../assets/graphics/png/collections/post_background/Pattern/post_text_bg_pattern11_01.png';
import Post_Text_Bg_Pattern11_02 from '../../assets/graphics/png/collections/post_background/Pattern/post_text_bg_pattern11_02.png';
import Post_Text_Bg_Pattern11_03 from '../../assets/graphics/png/collections/post_background/Pattern/post_text_bg_pattern11_03.png';
import Post_Text_Bg_Pattern11_04 from '../../assets/graphics/png/collections/post_background/Pattern/post_text_bg_pattern11_04.png';
import Post_Text_Bg_Pattern12_01 from '../../assets/graphics/png/collections/post_background/Pattern/post_text_bg_pattern12_01.png';
import Post_Text_Bg_Pattern12_02 from '../../assets/graphics/png/collections/post_background/Pattern/post_text_bg_pattern12_02.png';
import Post_Text_Bg_Pattern13_01 from '../../assets/graphics/png/collections/post_background/Pattern/post_text_bg_pattern13_01.png';
import Post_Text_Bg_Pattern13_02 from '../../assets/graphics/png/collections/post_background/Pattern/post_text_bg_pattern13_02.png';
import Post_Text_Bg_Pattern13_03 from '../../assets/graphics/png/collections/post_background/Pattern/post_text_bg_pattern13_03.png';
import Post_Text_Bg_Pattern13_04 from '../../assets/graphics/png/collections/post_background/Pattern/post_text_bg_pattern13_04.png';
import Post_Text_Bg_Pattern14_01 from '../../assets/graphics/png/collections/post_background/Pattern/post_text_bg_pattern14_01.png';
import Post_Text_Bg_Pattern14_02 from '../../assets/graphics/png/collections/post_background/Pattern/post_text_bg_pattern14_02.png';
import Post_Text_Bg_Pattern14_03 from '../../assets/graphics/png/collections/post_background/Pattern/post_text_bg_pattern14_03.png';
import Post_Text_Bg_Plant01_01 from '../../assets/graphics/png/collections/post_background/Plant/post_text_bg_plant01_01.png';
import Post_Text_Bg_Plant01_02 from '../../assets/graphics/png/collections/post_background/Plant/post_text_bg_plant01_02.png';
import Post_Text_Bg_Plant01_03 from '../../assets/graphics/png/collections/post_background/Plant/post_text_bg_plant01_03.png';
import Post_Text_Bg_Plant01_04 from '../../assets/graphics/png/collections/post_background/Plant/post_text_bg_plant01_04.png';
import Post_Text_Bg_Plant01_05 from '../../assets/graphics/png/collections/post_background/Plant/post_text_bg_plant01_05.png';
import Post_Text_Bg_Plant02_01 from '../../assets/graphics/png/collections/post_background/Plant/post_text_bg_plant02_01.png';
import Post_Text_Bg_Plant02_02 from '../../assets/graphics/png/collections/post_background/Plant/post_text_bg_plant02_02.png';
import Post_Text_Bg_Plant02_03 from '../../assets/graphics/png/collections/post_background/Plant/post_text_bg_plant02_03.png';
import Post_Text_Bg_Plant02_04 from '../../assets/graphics/png/collections/post_background/Plant/post_text_bg_plant02_04.png';
import Post_Text_Bg_Plant03_01 from '../../assets/graphics/png/collections/post_background/Plant/post_text_bg_plant03_01.png';
import Post_Text_Bg_Plant03_02 from '../../assets/graphics/png/collections/post_background/Plant/post_text_bg_plant03_02.png';
import Post_Text_Bg_Plant03_03 from '../../assets/graphics/png/collections/post_background/Plant/post_text_bg_plant03_03.png';
import Post_Text_Bg_Plant03_04 from '../../assets/graphics/png/collections/post_background/Plant/post_text_bg_plant03_04.png';
import Post_Text_Bg_Plant04_01 from '../../assets/graphics/png/collections/post_background/Plant/post_text_bg_plant04_01.png';
import Post_Text_Bg_Plant04_02 from '../../assets/graphics/png/collections/post_background/Plant/post_text_bg_plant04_02.png';
import Post_Text_Bg_Plant04_03 from '../../assets/graphics/png/collections/post_background/Plant/post_text_bg_plant04_03.png';
import Post_Text_Bg_Plant04_04 from '../../assets/graphics/png/collections/post_background/Plant/post_text_bg_plant04_04.png';
import Post_Text_Bg_Plant05_01 from '../../assets/graphics/png/collections/post_background/Plant/post_text_bg_plant05_01.png';
import Post_Text_Bg_Plant05_02 from '../../assets/graphics/png/collections/post_background/Plant/post_text_bg_plant05_02.png';
import Post_Text_Bg_Plant05_03 from '../../assets/graphics/png/collections/post_background/Plant/post_text_bg_plant05_03.png';
import Post_Text_Bg_Plant05_04 from '../../assets/graphics/png/collections/post_background/Plant/post_text_bg_plant05_04.png';
import Post_Text_Bg_Plant06_01 from '../../assets/graphics/png/collections/post_background/Plant/post_text_bg_plant06_01.png';
import Post_Text_Bg_Season01_01 from '../../assets/graphics/png/collections/post_background/Season/post_text_bg_season01_01.png';
import Post_Text_Bg_Season02_01 from '../../assets/graphics/png/collections/post_background/Season/post_text_bg_season02_01.png';
import Post_Text_Bg_Season03_01 from '../../assets/graphics/png/collections/post_background/Season/post_text_bg_season03_01.png';
import Post_Text_Bg_Season04_01 from '../../assets/graphics/png/collections/post_background/Season/post_text_bg_season04_01.png';
import Post_Text_Bg_Texture01_01 from '../../assets/graphics/png/collections/post_background/Texture/post_text_bg_texture01_01.png';
import Post_Text_Bg_Texture01_02 from '../../assets/graphics/png/collections/post_background/Texture/post_text_bg_texture01_02.png';
import Post_Text_Bg_Texture01_03 from '../../assets/graphics/png/collections/post_background/Texture/post_text_bg_texture01_03.png';
import Post_Text_Bg_Texture01_04 from '../../assets/graphics/png/collections/post_background/Texture/post_text_bg_texture01_04.png';
import Post_Text_Bg_Texture02_01 from '../../assets/graphics/png/collections/post_background/Texture/post_text_bg_texture02_01.png';
import Post_Text_Bg_Texture02_02 from '../../assets/graphics/png/collections/post_background/Texture/post_text_bg_texture02_02.png';
import Post_Text_Bg_Texture03_01 from '../../assets/graphics/png/collections/post_background/Texture/post_text_bg_texture03_01.png';
import Post_Text_Bg_Texture03_02 from '../../assets/graphics/png/collections/post_background/Texture/post_text_bg_texture03_02.png';
import Post_Text_Bg_Texture03_03 from '../../assets/graphics/png/collections/post_background/Texture/post_text_bg_texture03_03.png';
import Post_Text_Bg_Texture04_01 from '../../assets/graphics/png/collections/post_background/Texture/post_text_bg_texture04_01.png';
import Post_Text_Bg_Texture04_02 from '../../assets/graphics/png/collections/post_background/Texture/post_text_bg_texture04_02.png';
import Post_Text_Bg_Texture05_01 from '../../assets/graphics/png/collections/post_background/Texture/post_text_bg_texture05_01.png';
import Post_Text_Bg_Texture05_02 from '../../assets/graphics/png/collections/post_background/Texture/post_text_bg_texture05_02.png';
import Post_Text_Bg_Texture05_03 from '../../assets/graphics/png/collections/post_background/Texture/post_text_bg_texture05_03.png';
import Post_Text_Bg_Texture06_01 from '../../assets/graphics/png/collections/post_background/Texture/post_text_bg_texture06_01.png';
import Post_Text_Bg_Texture06_02 from '../../assets/graphics/png/collections/post_background/Texture/post_text_bg_texture06_02.png';
import Post_Text_Bg_Texture06_03 from '../../assets/graphics/png/collections/post_background/Texture/post_text_bg_texture06_03.png';
import Post_Text_Bg_Texture06_04 from '../../assets/graphics/png/collections/post_background/Texture/post_text_bg_texture06_04.png';
import Post_Text_Bg_Texture07_01 from '../../assets/graphics/png/collections/post_background/Texture/post_text_bg_texture07_01.png';
import Post_Text_Bg_Texture08_01 from '../../assets/graphics/png/collections/post_background/Texture/post_text_bg_texture08_01.png';
import Post_Text_Bg_Texture08_02 from '../../assets/graphics/png/collections/post_background/Texture/post_text_bg_texture08_02.png';
import Post_Text_Bg_Texture09_01 from '../../assets/graphics/png/collections/post_background/Texture/post_text_bg_texture09_01.png';
import Post_Text_Bg_Texture09_02 from '../../assets/graphics/png/collections/post_background/Texture/post_text_bg_texture09_02.png';
import Post_Text_Bg_Texture09_03 from '../../assets/graphics/png/collections/post_background/Texture/post_text_bg_texture09_03.png';
import Post_Text_Bg_Texture09_04 from '../../assets/graphics/png/collections/post_background/Texture/post_text_bg_texture09_04.png';
import Post_Text_Bg_Texture10_01 from '../../assets/graphics/png/collections/post_background/Texture/post_text_bg_texture10_01.png';
import Post_Text_Bg_Texture10_02 from '../../assets/graphics/png/collections/post_background/Texture/post_text_bg_texture10_02.png';
import Post_Text_Bg_Weather01_01 from '../../assets/graphics/png/collections/post_background/Weather/post_text_bg_weather01_01.png';
import Post_Text_Bg_Weather02_01 from '../../assets/graphics/png/collections/post_background/Weather/post_text_bg_weather02_01.png';
import Post_Text_Bg_Weather02_02 from '../../assets/graphics/png/collections/post_background/Weather/post_text_bg_weather02_02.png';
import Post_Text_Bg_Weather02_03 from '../../assets/graphics/png/collections/post_background/Weather/post_text_bg_weather02_03.png';
import Post_Text_Bg_Weather02_04 from '../../assets/graphics/png/collections/post_background/Weather/post_text_bg_weather02_04.png';
import Post_Text_Bg_Weather03_01 from '../../assets/graphics/png/collections/post_background/Weather/post_text_bg_weather03_01.png';
import Post_Text_Bg_Weather03_02 from '../../assets/graphics/png/collections/post_background/Weather/post_text_bg_weather03_02.png';
import Post_Text_Bg_Weather03_03 from '../../assets/graphics/png/collections/post_background/Weather/post_text_bg_weather03_03.png';
import Post_Text_Bg_Weather03_04 from '../../assets/graphics/png/collections/post_background/Weather/post_text_bg_weather03_04.png';
import Post_Text_Bg_Weather04_01 from '../../assets/graphics/png/collections/post_background/Weather/post_text_bg_weather04_01.png';
import Post_Text_Bg_Weather04_02 from '../../assets/graphics/png/collections/post_background/Weather/post_text_bg_weather04_02.png';
import Post_Text_Bg_Weather04_03 from '../../assets/graphics/png/collections/post_background/Weather/post_text_bg_weather04_03.png';
import Post_Text_Bg_Weather04_04 from '../../assets/graphics/png/collections/post_background/Weather/post_text_bg_weather04_04.png';
import Post_Text_Bg_Weather05_01 from '../../assets/graphics/png/collections/post_background/Weather/post_text_bg_weather05_01.png';
import Post_Text_Bg_Weather05_02 from '../../assets/graphics/png/collections/post_background/Weather/post_text_bg_weather05_02.png';
import Post_Text_Bg_Weather05_03 from '../../assets/graphics/png/collections/post_background/Weather/post_text_bg_weather05_03.png';
import Post_Text_Bg_Weather06_01 from '../../assets/graphics/png/collections/post_background/Weather/post_text_bg_weather06_01.png';
import Post_Text_Bg_Weather06_02 from '../../assets/graphics/png/collections/post_background/Weather/post_text_bg_weather06_02.png';
import Post_Text_Bg_Weather06_03 from '../../assets/graphics/png/collections/post_background/Weather/post_text_bg_weather06_03.png';
import Post_Text_Bg_Weather07_01 from '../../assets/graphics/png/collections/post_background/Weather/post_text_bg_weather07_01.png';
import Post_Text_Bg_Weather07_02 from '../../assets/graphics/png/collections/post_background/Weather/post_text_bg_weather07_02.png';
import Post_Text_Bg_Weather07_03 from '../../assets/graphics/png/collections/post_background/Weather/post_text_bg_weather07_03.png';
import Post_Text_Bg_Weather07_04 from '../../assets/graphics/png/collections/post_background/Weather/post_text_bg_weather07_04.png';
import Post_Text_Bg_Weather07_05 from '../../assets/graphics/png/collections/post_background/Weather/post_text_bg_weather07_05.png';
import Post_Text_Bg_Weather07_06 from '../../assets/graphics/png/collections/post_background/Weather/post_text_bg_weather07_06.png';
import Post_Text_Bg_Weather08_01 from '../../assets/graphics/png/collections/post_background/Weather/post_text_bg_weather08_01.png';
import Post_Text_Bg_Weather08_02 from '../../assets/graphics/png/collections/post_background/Weather/post_text_bg_weather08_02.png';
import Post_Text_Bg_Weather08_03 from '../../assets/graphics/png/collections/post_background/Weather/post_text_bg_weather08_03.png';
import Post_Text_Bg_Weather08_04 from '../../assets/graphics/png/collections/post_background/Weather/post_text_bg_weather08_04.png';
import Post_Text_Bg_Weather09_01 from '../../assets/graphics/png/collections/post_background/Weather/post_text_bg_weather09_01.png';
import Post_Text_Bg_Weather10_01 from '../../assets/graphics/png/collections/post_background/Weather/post_text_bg_weather10_01.png';
import Post_Text_Bg_Weather10_02 from '../../assets/graphics/png/collections/post_background/Weather/post_text_bg_weather10_02.png';
import Post_Text_Bg_Weather10_03 from '../../assets/graphics/png/collections/post_background/Weather/post_text_bg_weather10_03.png';
import Post_Text_Bg_Weather10_04 from '../../assets/graphics/png/collections/post_background/Weather/post_text_bg_weather10_04.png';
import Post_Text_Bg_Weather11_01 from '../../assets/graphics/png/collections/post_background/Weather/post_text_bg_weather11_01.png';
import Post_Text_Bg_Weather11_02 from '../../assets/graphics/png/collections/post_background/Weather/post_text_bg_weather11_02.png';

export enum PostBackgroundItemNo {
  p1 = 'posts-backgrounds-00000001',
  p2 = 'posts-backgrounds-00000002',
  p3 = 'posts-backgrounds-00000003',
  p4 = 'posts-backgrounds-00000004',
  p5 = 'posts-backgrounds-00000005',
  p6 = 'posts-backgrounds-00000006',
  p7 = 'posts-backgrounds-00000007',
  p8 = 'posts-backgrounds-00000008',
  p9 = 'posts-backgrounds-00000009',
  p10 = 'posts-backgrounds-00000010',
  p11 = 'posts-backgrounds-00000011',
  p12 = 'posts-backgrounds-00000012',
  p13 = 'posts-backgrounds-00000013',
  p14 = 'posts-backgrounds-00000014',
  p15 = 'posts-backgrounds-00000015',
  p16 = 'posts-backgrounds-00000016',
  p17 = 'posts-backgrounds-00000017',
  p18 = 'posts-backgrounds-00000018',
  p19 = 'posts-backgrounds-00000019',
  p20 = 'posts-backgrounds-00000020',
  p21 = 'posts-backgrounds-00000021',
  p22 = 'posts-backgrounds-00000022',
  p23 = 'posts-backgrounds-00000023',
  p24 = 'posts-backgrounds-00000024',
  p25 = 'posts-backgrounds-00000025',
  p26 = 'posts-backgrounds-00000026',
  p27 = 'posts-backgrounds-00000027',
  p28 = 'posts-backgrounds-00000028',
  p29 = 'posts-backgrounds-00000029',
  p30 = 'posts-backgrounds-00000030',
  p31 = 'posts-backgrounds-00000031',
  p32 = 'posts-backgrounds-00000032',
  p33 = 'posts-backgrounds-00000033',
  p34 = 'posts-backgrounds-00000034',
  p35 = 'posts-backgrounds-00000035',
  p36 = 'posts-backgrounds-00000036',
  p37 = 'posts-backgrounds-00000037',
  p38 = 'posts-backgrounds-00000038',
  p39 = 'posts-backgrounds-00000039',
  p40 = 'posts-backgrounds-00000040',
  p41 = 'posts-backgrounds-00000041',
  p42 = 'posts-backgrounds-00000042',
  p43 = 'posts-backgrounds-00000043',
  p44 = 'posts-backgrounds-00000044',
  p45 = 'posts-backgrounds-00000045',
  p46 = 'posts-backgrounds-00000046',
  p47 = 'posts-backgrounds-00000047',
  p48 = 'posts-backgrounds-00000048',
  p49 = 'posts-backgrounds-00000049',
  p50 = 'posts-backgrounds-00000050',
  p51 = 'posts-backgrounds-00000051',
  p52 = 'posts-backgrounds-00000052',
  p53 = 'posts-backgrounds-00000053',
  p54 = 'posts-backgrounds-00000054',
  p55 = 'posts-backgrounds-00000055',
  p56 = 'posts-backgrounds-00000056',
  p57 = 'posts-backgrounds-00000057',
  p58 = 'posts-backgrounds-00000058',
  p59 = 'posts-backgrounds-00000059',
  p60 = 'posts-backgrounds-00000060',
  p61 = 'posts-backgrounds-00000061',
  p62 = 'posts-backgrounds-00000062',
  p63 = 'posts-backgrounds-00000063',
  p64 = 'posts-backgrounds-00000064',
  p65 = 'posts-backgrounds-00000065',
  p66 = 'posts-backgrounds-00000066',
  p67 = 'posts-backgrounds-00000067',
  p68 = 'posts-backgrounds-00000068',
  p69 = 'posts-backgrounds-00000069',
  p70 = 'posts-backgrounds-00000070',
  p71 = 'posts-backgrounds-00000071',
  p72 = 'posts-backgrounds-00000072',
  p73 = 'posts-backgrounds-00000073',
  p74 = 'posts-backgrounds-00000074',
  p75 = 'posts-backgrounds-00000075',
  p76 = 'posts-backgrounds-00000076',
  p77 = 'posts-backgrounds-00000077',
  p78 = 'posts-backgrounds-00000078',
  p79 = 'posts-backgrounds-00000079',
  p80 = 'posts-backgrounds-00000080',
  p81 = 'posts-backgrounds-00000081',
  p82 = 'posts-backgrounds-00000082',
  p83 = 'posts-backgrounds-00000083',
  p84 = 'posts-backgrounds-00000084',
  p85 = 'posts-backgrounds-00000085',
  p86 = 'posts-backgrounds-00000086',
  p87 = 'posts-backgrounds-00000087',
  p88 = 'posts-backgrounds-00000088',
  p89 = 'posts-backgrounds-00000089',
  p90 = 'posts-backgrounds-00000090',
  p91 = 'posts-backgrounds-00000091',
  p92 = 'posts-backgrounds-00000092',
  p93 = 'posts-backgrounds-00000093',
  p94 = 'posts-backgrounds-00000094',
  p95 = 'posts-backgrounds-00000095',
  p96 = 'posts-backgrounds-00000096',
  p97 = 'posts-backgrounds-00000097',
  p98 = 'posts-backgrounds-00000098',
  p99 = 'posts-backgrounds-00000099',
  p100 = 'posts-backgrounds-00000100',
  p101 = 'posts-backgrounds-00000101',
  p102 = 'posts-backgrounds-00000102',
  p103 = 'posts-backgrounds-00000103',
  p104 = 'posts-backgrounds-00000104',
  p105 = 'posts-backgrounds-00000105',
  p106 = 'posts-backgrounds-00000106',
  p107 = 'posts-backgrounds-00000107',
  p108 = 'posts-backgrounds-00000108',
  p109 = 'posts-backgrounds-00000109',
  p110 = 'posts-backgrounds-00000110',
  p111 = 'posts-backgrounds-00000111',
  p112 = 'posts-backgrounds-00000112',
  p113 = 'posts-backgrounds-00000113',
  p114 = 'posts-backgrounds-00000114',
  p115 = 'posts-backgrounds-00000115',
  p116 = 'posts-backgrounds-00000116',
  p117 = 'posts-backgrounds-00000117',
  p118 = 'posts-backgrounds-00000118',
  p119 = 'posts-backgrounds-00000119',
  p120 = 'posts-backgrounds-00000120',
  p121 = 'posts-backgrounds-00000121',
  p122 = 'posts-backgrounds-00000122',
  p123 = 'posts-backgrounds-00000123',
  p124 = 'posts-backgrounds-00000124',
  p125 = 'posts-backgrounds-00000125',
  p126 = 'posts-backgrounds-00000126',
  p127 = 'posts-backgrounds-00000127',
  p128 = 'posts-backgrounds-00000128',
  p129 = 'posts-backgrounds-00000129',
  p130 = 'posts-backgrounds-00000130',
  p131 = 'posts-backgrounds-00000131',
  p132 = 'posts-backgrounds-00000132',
  p133 = 'posts-backgrounds-00000133',
  p134 = 'posts-backgrounds-00000134',
  p135 = 'posts-backgrounds-00000135',
  p136 = 'posts-backgrounds-00000136',
  p137 = 'posts-backgrounds-00000137',
  p138 = 'posts-backgrounds-00000138',
  p139 = 'posts-backgrounds-00000139',
  p140 = 'posts-backgrounds-00000140',
  p141 = 'posts-backgrounds-00000141',
  p142 = 'posts-backgrounds-00000142',
  p143 = 'posts-backgrounds-00000143',
  p144 = 'posts-backgrounds-00000144',
  p145 = 'posts-backgrounds-00000145',
  p146 = 'posts-backgrounds-00000146',
  p147 = 'posts-backgrounds-00000147',
  p148 = 'posts-backgrounds-00000148',
  p149 = 'posts-backgrounds-00000149',
  p150 = 'posts-backgrounds-00000150',
  p151 = 'posts-backgrounds-00000151',
  p152 = 'posts-backgrounds-00000152',
  p153 = 'posts-backgrounds-00000153',
  p154 = 'posts-backgrounds-00000154',
  p155 = 'posts-backgrounds-00000155',
  p156 = 'posts-backgrounds-00000156',
  p157 = 'posts-backgrounds-00000157',
  p158 = 'posts-backgrounds-00000158',
  p159 = 'posts-backgrounds-00000159',
  p160 = 'posts-backgrounds-00000160',
  p161 = 'posts-backgrounds-00000161',
  p162 = 'posts-backgrounds-00000162',
  p163 = 'posts-backgrounds-00000163',
  p164 = 'posts-backgrounds-00000164',
  p165 = 'posts-backgrounds-00000165',
  p166 = 'posts-backgrounds-00000166',
  p167 = 'posts-backgrounds-00000167',
  p168 = 'posts-backgrounds-00000168',
  p169 = 'posts-backgrounds-00000169',
  p170 = 'posts-backgrounds-00000170',
  p171 = 'posts-backgrounds-00000171',
  p172 = 'posts-backgrounds-00000172',
  p173 = 'posts-backgrounds-00000173',
  p174 = 'posts-backgrounds-00000174',
  p175 = 'posts-backgrounds-00000175',
  p176 = 'posts-backgrounds-00000176',
  p177 = 'posts-backgrounds-00000177',
  p178 = 'posts-backgrounds-00000178',
  p179 = 'posts-backgrounds-00000179',
  p180 = 'posts-backgrounds-00000180',
  p181 = 'posts-backgrounds-00000181',
  p182 = 'posts-backgrounds-00000182',
  p183 = 'posts-backgrounds-00000183',
  p184 = 'posts-backgrounds-00000184',
  p185 = 'posts-backgrounds-00000185',
  p186 = 'posts-backgrounds-00000186',
  p187 = 'posts-backgrounds-00000187',
  p188 = 'posts-backgrounds-00000188',
  p189 = 'posts-backgrounds-00000189',
  p190 = 'posts-backgrounds-00000190',
  p191 = 'posts-backgrounds-00000191',
  p192 = 'posts-backgrounds-00000192',
  p193 = 'posts-backgrounds-00000193',
  p194 = 'posts-backgrounds-00000194',
  p195 = 'posts-backgrounds-00000195',
  p196 = 'posts-backgrounds-00000196',
  p197 = 'posts-backgrounds-00000197',
  p198 = 'posts-backgrounds-00000198',
  p199 = 'posts-backgrounds-00000199',
  p200 = 'posts-backgrounds-00000200',
  p201 = 'posts-backgrounds-00000201',
  p202 = 'posts-backgrounds-00000202',
  p203 = 'posts-backgrounds-00000203',
  p204 = 'posts-backgrounds-00000204',
  p205 = 'posts-backgrounds-00000205',
  p206 = 'posts-backgrounds-00000206',
  p207 = 'posts-backgrounds-00000207',
  p208 = 'posts-backgrounds-00000208',
  p209 = 'posts-backgrounds-00000209',
  p210 = 'posts-backgrounds-00000210',
  p211 = 'posts-backgrounds-00000211',
  p212 = 'posts-backgrounds-00000212',
  p213 = 'posts-backgrounds-00000213',
  p214 = 'posts-backgrounds-00000214',
  p215 = 'posts-backgrounds-00000215',
  p216 = 'posts-backgrounds-00000216',
  p217 = 'posts-backgrounds-00000217',
  p218 = 'posts-backgrounds-00000218',
  p219 = 'posts-backgrounds-00000219',
  p220 = 'posts-backgrounds-00000220',
  p221 = 'posts-backgrounds-00000221',
  p222 = 'posts-backgrounds-00000222',
  p223 = 'posts-backgrounds-00000223',
  p224 = 'posts-backgrounds-00000224',
  p225 = 'posts-backgrounds-00000225',
  p226 = 'posts-backgrounds-00000226',
  p227 = 'posts-backgrounds-00000227',
  p228 = 'posts-backgrounds-00000228',
  p229 = 'posts-backgrounds-00000229',
  p230 = 'posts-backgrounds-00000230',
  p231 = 'posts-backgrounds-00000231',
  p232 = 'posts-backgrounds-00000232',
  p233 = 'posts-backgrounds-00000233',
  p234 = 'posts-backgrounds-00000234',
  p235 = 'posts-backgrounds-00000235',
  p236 = 'posts-backgrounds-00000236',
  p237 = 'posts-backgrounds-00000237',
  p238 = 'posts-backgrounds-00000238',
  p239 = 'posts-backgrounds-00000239',
  p240 = 'posts-backgrounds-00000240',
  p241 = 'posts-backgrounds-00000241',
  p242 = 'posts-backgrounds-00000242',
  p243 = 'posts-backgrounds-00000243',
  p244 = 'posts-backgrounds-00000244',
  p245 = 'posts-backgrounds-00000245',
  p246 = 'posts-backgrounds-00000246',
  p247 = 'posts-backgrounds-00000247',
  p248 = 'posts-backgrounds-00000248',
  p249 = 'posts-backgrounds-00000249',
  p250 = 'posts-backgrounds-00000250',
  p251 = 'posts-backgrounds-00000251',
  p252 = 'posts-backgrounds-00000252',
  p253 = 'posts-backgrounds-00000253',
  p254 = 'posts-backgrounds-00000254',
  p255 = 'posts-backgrounds-00000255',
  p256 = 'posts-backgrounds-00000256',
  p257 = 'posts-backgrounds-00000257',
  p258 = 'posts-backgrounds-00000258',
  p259 = 'posts-backgrounds-00000259',
  p260 = 'posts-backgrounds-00000260',
  p261 = 'posts-backgrounds-00000261',
  p262 = 'posts-backgrounds-00000262',
  p263 = 'posts-backgrounds-00000263',
  p264 = 'posts-backgrounds-00000264',
  p265 = 'posts-backgrounds-00000265',
  p266 = 'posts-backgrounds-00000266',
  p267 = 'posts-backgrounds-00000267',
  p268 = 'posts-backgrounds-00000268',
  p269 = 'posts-backgrounds-00000269',
  p270 = 'posts-backgrounds-00000270',
  p271 = 'posts-backgrounds-00000271',
  p272 = 'posts-backgrounds-00000272',
}

enum PostBackgroundSet {
  Animal = 'animal',
  Celebration = 'celebration',
  Color = 'color',
  Fruit = 'fruit',
  Funny = 'funny',
  Gradient = 'gradient',
  Pattern = 'pattern',
  Plant = 'plant',
  Season = 'season',
  Texture = 'texture',
  Weather = 'weather',
}

type PostVisual = {
  filePrefix: string;
  thumbnailPrefix?: string | null; // Optional in TypeScript, denoted by '?'
  textColor: string; // Changed to string type
  dotColor: string; // Changed to string type
  smallDotColor?: string | null; // Changed to string type and made optional
  hasThumbnail: boolean;
};

type PostBackground = {
  itemId: PostBackgroundItemNo;
  category: string;
  subcategory: string;
  type: string;
  set: PostBackgroundSet;
  isVisible: boolean;
  visual: PostVisual;
  dependedItem?: PostBackgroundItemNo | null;
};

export const POST_BACKGROUNDS = Object.freeze<PostBackground[]>([
  {
    itemId: PostBackgroundItemNo.p1,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Color,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Color01_01,
      thumbnailPrefix: Post_Text_Bg_Color01_01_Th,
      textColor: '#000000',
      dotColor: '#ffffff',
      smallDotColor: null,
      hasThumbnail: true,
    },
    dependedItem: null,
  },
  {
    itemId: PostBackgroundItemNo.p2,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Color,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Color02_01,
      thumbnailPrefix: Post_Text_Bg_Color02_01_Th,
      textColor: '#ffffff',
      dotColor: '#000000',
      smallDotColor: null,
      hasThumbnail: true,
    },
    dependedItem: null,
  },
  {
    itemId: PostBackgroundItemNo.p3,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Color,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Color03_01,
      thumbnailPrefix: Post_Text_Bg_Color03_01_Th,
      textColor: '#ffffff',
      dotColor: '#ef4b48',
      smallDotColor: null,
      hasThumbnail: true,
    },
    dependedItem: null,
  },
  {
    itemId: PostBackgroundItemNo.p4,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Color,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Color04_01,
      thumbnailPrefix: Post_Text_Bg_Color04_01_Th,
      textColor: '#000000',
      dotColor: '#ee8d27',
      smallDotColor: null,
      hasThumbnail: true,
    },
    dependedItem: null,
  },
  {
    itemId: PostBackgroundItemNo.p5,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Color,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Color05_01,
      thumbnailPrefix: Post_Text_Bg_Color05_01_Th,
      textColor: '#000000',
      dotColor: '#f8d032',
      smallDotColor: null,
      hasThumbnail: true,
    },
    dependedItem: null,
  },
  {
    itemId: PostBackgroundItemNo.p6,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Color,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Color06_01,
      thumbnailPrefix: Post_Text_Bg_Color06_01_Th,
      textColor: '#000000',
      dotColor: '#86bd43',
      smallDotColor: null,
      hasThumbnail: true,
    },
    dependedItem: null,
  },
  {
    itemId: PostBackgroundItemNo.p7,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Color,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Color07_01,
      thumbnailPrefix: Post_Text_Bg_Color07_01_Th,
      textColor: '#ffffff',
      dotColor: '#2ca3d3',
      smallDotColor: null,
      hasThumbnail: true,
    },
    dependedItem: null,
  },
  {
    itemId: PostBackgroundItemNo.p8,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Color,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Color08_01,
      thumbnailPrefix: Post_Text_Bg_Color08_01_Th,
      textColor: '#ffffff',
      dotColor: '#4b6ab1',
      smallDotColor: null,
      hasThumbnail: true,
    },
    dependedItem: null,
  },
  {
    itemId: PostBackgroundItemNo.p9,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Color,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Color09_01,
      thumbnailPrefix: Post_Text_Bg_Color09_01_Th,
      textColor: '#ffffff',
      dotColor: '#b959a1',
      smallDotColor: null,
      hasThumbnail: true,
    },
    dependedItem: null,
  },
  {
    itemId: PostBackgroundItemNo.p10,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Color,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Color10_01,
      thumbnailPrefix: Post_Text_Bg_Color10_01_Th,
      textColor: '#000000',
      dotColor: '#faafe8',
      smallDotColor: null,
      hasThumbnail: true,
    },
    dependedItem: null,
  },
  {
    itemId: PostBackgroundItemNo.p11,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Color,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Color11_01,
      thumbnailPrefix: Post_Text_Bg_Color11_01_Th,
      textColor: '#ffffff',
      dotColor: '#00ba95',
      smallDotColor: null,
      hasThumbnail: true,
    },
    dependedItem: null,
  },
  {
    itemId: PostBackgroundItemNo.p12,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Color,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Color12_01,
      thumbnailPrefix: Post_Text_Bg_Color12_01_Th,
      textColor: '#000000',
      dotColor: '#999999',
      smallDotColor: null,
      hasThumbnail: true,
    },
    dependedItem: null,
  },
  {
    itemId: PostBackgroundItemNo.p13,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Gradient,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Gradient01_01,
      thumbnailPrefix: Post_Text_Bg_Gradient01_01_Th,
      textColor: '#ffffff',
      dotColor: '#7eb7ad',
      smallDotColor: null,
      hasThumbnail: true,
    },
    dependedItem: null,
  },
  {
    itemId: PostBackgroundItemNo.p14,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Gradient,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Gradient02_01,
      thumbnailPrefix: Post_Text_Bg_Gradient02_01_Th,
      textColor: '#ffffff',
      dotColor: '#87b368',
      smallDotColor: null,
      hasThumbnail: true,
    },
    dependedItem: null,
  },
  {
    itemId: PostBackgroundItemNo.p15,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Gradient,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Gradient03_01,
      thumbnailPrefix: Post_Text_Bg_Gradient03_01_Th,
      textColor: '#ffffff',
      dotColor: '#6e85bd',
      smallDotColor: null,
      hasThumbnail: true,
    },
    dependedItem: null,
  },
  {
    itemId: PostBackgroundItemNo.p16,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Gradient,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Gradient04_01,
      thumbnailPrefix: Post_Text_Bg_Gradient04_01_Th,
      textColor: '#ffffff',
      dotColor: '#a06ebd',
      smallDotColor: null,
      hasThumbnail: true,
    },
    dependedItem: null,
  },
  {
    itemId: PostBackgroundItemNo.p17,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Gradient,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Gradient05_01,
      thumbnailPrefix: Post_Text_Bg_Gradient05_01_Th,
      textColor: '#ffffff',
      dotColor: '#f0607a',
      smallDotColor: null,
      hasThumbnail: true,
    },
    dependedItem: null,
  },
  {
    itemId: PostBackgroundItemNo.p18,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Gradient,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Gradient06_01,
      thumbnailPrefix: Post_Text_Bg_Gradient06_01_Th,
      textColor: '#000000',
      dotColor: '#fff733',
      smallDotColor: null,
      hasThumbnail: true,
    },
    dependedItem: null,
  },
  {
    itemId: PostBackgroundItemNo.p19,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Gradient,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Gradient07_01,
      thumbnailPrefix: Post_Text_Bg_Gradient07_01_Th,
      textColor: '#000000',
      dotColor: '#ddb2f9',
      smallDotColor: null,
      hasThumbnail: true,
    },
    dependedItem: null,
  },
  {
    itemId: PostBackgroundItemNo.p20,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Gradient,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Gradient08_01,
      thumbnailPrefix: Post_Text_Bg_Gradient08_01_Th,
      textColor: '#000000',
      dotColor: '#66f990',
      smallDotColor: null,
      hasThumbnail: true,
    },
    dependedItem: null,
  },
  {
    itemId: PostBackgroundItemNo.p21,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Gradient,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Gradient09_01,
      thumbnailPrefix: Post_Text_Bg_Gradient09_01_Th,
      textColor: '#ffffff',
      dotColor: '#0030a3',
      smallDotColor: null,
      hasThumbnail: true,
    },
    dependedItem: null,
  },
  {
    itemId: PostBackgroundItemNo.p22,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Gradient,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Gradient10_01,
      thumbnailPrefix: Post_Text_Bg_Gradient10_01_Th,
      textColor: '#ffffff',
      dotColor: '#000000',
      smallDotColor: null,
      hasThumbnail: true,
    },
    dependedItem: null,
  },
  {
    itemId: PostBackgroundItemNo.p23,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Gradient,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Gradient11_01,
      thumbnailPrefix: Post_Text_Bg_Gradient11_01_Th,
      textColor: '#ffffff',
      dotColor: '#ff69be',
      smallDotColor: null,
      hasThumbnail: true,
    },
    dependedItem: null,
  },
  {
    itemId: PostBackgroundItemNo.p24,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Gradient,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Gradient12_01,
      thumbnailPrefix: Post_Text_Bg_Gradient12_01_Th,
      textColor: '#000000',
      dotColor: '#8a69ff',
      smallDotColor: null,
      hasThumbnail: true,
    },
    dependedItem: null,
  },
  {
    itemId: PostBackgroundItemNo.p25,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Gradient,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Gradient13_01,
      thumbnailPrefix: Post_Text_Bg_Gradient13_01_Th,
      textColor: '#ffffff',
      dotColor: '#bf1111',
      smallDotColor: null,
      hasThumbnail: true,
    },
    dependedItem: null,
  },
  {
    itemId: PostBackgroundItemNo.p26,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Gradient,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Gradient14_01,
      thumbnailPrefix: Post_Text_Bg_Gradient14_01_Th,
      textColor: '#000000',
      dotColor: '#84cfeb',
      smallDotColor: null,
      hasThumbnail: true,
    },
    dependedItem: null,
  },
  {
    itemId: PostBackgroundItemNo.p27,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Gradient,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Gradient15_01,
      thumbnailPrefix: Post_Text_Bg_Gradient15_01_Th,
      textColor: '#ffffff',
      dotColor: '#b8ed32',
      smallDotColor: null,
      hasThumbnail: true,
    },
    dependedItem: null,
  },
  {
    itemId: PostBackgroundItemNo.p28,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Gradient,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Gradient16_01,
      thumbnailPrefix: Post_Text_Bg_Gradient16_01_Th,
      textColor: '#ffffff',
      dotColor: '#002c7d',
      smallDotColor: null,
      hasThumbnail: true,
    },
    dependedItem: null,
  },
  {
    itemId: PostBackgroundItemNo.p29,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Pattern,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Pattern01_01,
      thumbnailPrefix: Post_Text_Bg_Pattern01_01_Th,
      textColor: '#ffffff',
      dotColor: '#2b2d52',
      smallDotColor: '#ffffff',
      hasThumbnail: true,
    },
    dependedItem: null,
  },
  {
    itemId: PostBackgroundItemNo.p30,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Pattern,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Pattern01_02,
      thumbnailPrefix: null,
      textColor: '#000000',
      dotColor: '#ffffff',
      smallDotColor: null,
      hasThumbnail: false,
    },
    dependedItem: PostBackgroundItemNo.p29,
  },
  {
    itemId: PostBackgroundItemNo.p31,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Pattern,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Pattern01_03,
      thumbnailPrefix: null,
      textColor: '#ffffff',
      dotColor: '#000000',
      smallDotColor: null,
      hasThumbnail: false,
    },
    dependedItem: PostBackgroundItemNo.p29,
  },
  {
    itemId: PostBackgroundItemNo.p32,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Pattern,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Pattern02_01,
      thumbnailPrefix: Post_Text_Bg_Pattern02_01_Th,
      textColor: '#ffffff',
      dotColor: '#ffa6ca',
      smallDotColor: '#e7a2fa',
      hasThumbnail: true,
    },
    dependedItem: null,
  },
  {
    itemId: PostBackgroundItemNo.p33,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Pattern,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Pattern02_02,
      thumbnailPrefix: null,
      textColor: '#ffffff',
      dotColor: '#e7a2fa',
      smallDotColor: null,
      hasThumbnail: false,
    },
    dependedItem: PostBackgroundItemNo.p32,
  },
  {
    itemId: PostBackgroundItemNo.p34,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Pattern,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Pattern02_03,
      thumbnailPrefix: null,
      textColor: '#ffffff',
      dotColor: '#86b4fa',
      smallDotColor: null,
      hasThumbnail: false,
    },
    dependedItem: PostBackgroundItemNo.p32,
  },
  {
    itemId: PostBackgroundItemNo.p35,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Pattern,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Pattern02_04,
      thumbnailPrefix: null,
      textColor: '#ffffff',
      dotColor: '#ffc161',
      smallDotColor: null,
      hasThumbnail: false,
    },
    dependedItem: PostBackgroundItemNo.p32,
  },
  {
    itemId: PostBackgroundItemNo.p36,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Pattern,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Pattern03_01,
      thumbnailPrefix: Post_Text_Bg_Pattern03_01_Th,
      textColor: '#000000',
      dotColor: '#ffffff',
      smallDotColor: '#000000',
      hasThumbnail: true,
    },
    dependedItem: null,
  },
  {
    itemId: PostBackgroundItemNo.p37,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Pattern,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Pattern03_02,
      thumbnailPrefix: null,
      textColor: '#ffffff',
      dotColor: '#000000',
      smallDotColor: null,
      hasThumbnail: false,
    },
    dependedItem: PostBackgroundItemNo.p36,
  },
  {
    itemId: PostBackgroundItemNo.p38,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Pattern,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Pattern03_03,
      thumbnailPrefix: null,
      textColor: '#ffffff',
      dotColor: '#18285c',
      smallDotColor: null,
      hasThumbnail: false,
    },
    dependedItem: PostBackgroundItemNo.p36,
  },
  {
    itemId: PostBackgroundItemNo.p39,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Pattern,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Pattern04_01,
      thumbnailPrefix: Post_Text_Bg_Pattern04_01_Th,
      textColor: '#000000',
      dotColor: '#ffffff',
      smallDotColor: '#422921',
      hasThumbnail: true,
    },
    dependedItem: null,
  },
  {
    itemId: PostBackgroundItemNo.p40,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Pattern,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Pattern04_02,
      thumbnailPrefix: null,
      textColor: '#ffffff',
      dotColor: '#422921',
      smallDotColor: null,
      hasThumbnail: false,
    },
    dependedItem: PostBackgroundItemNo.p39,
  },
  {
    itemId: PostBackgroundItemNo.p41,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Pattern,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Pattern04_03,
      thumbnailPrefix: null,
      textColor: '#ffffff',
      dotColor: '#18285c',
      smallDotColor: null,
      hasThumbnail: false,
    },
    dependedItem: PostBackgroundItemNo.p39,
  },
  {
    itemId: PostBackgroundItemNo.p42,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Pattern,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Pattern05_01,
      thumbnailPrefix: Post_Text_Bg_Pattern05_01_Th,
      textColor: '#000000',
      dotColor: '#80cfc4',
      smallDotColor: '#92cf65',
      hasThumbnail: true,
    },
    dependedItem: null,
  },
  {
    itemId: PostBackgroundItemNo.p43,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Pattern,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Pattern05_02,
      thumbnailPrefix: null,
      textColor: '#000000',
      dotColor: '#92cf65',
      smallDotColor: null,
      hasThumbnail: false,
    },
    dependedItem: PostBackgroundItemNo.p42,
  },
  {
    itemId: PostBackgroundItemNo.p44,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Pattern,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Pattern05_03,
      thumbnailPrefix: null,
      textColor: '#000000',
      dotColor: '#5d9ccf',
      smallDotColor: null,
      hasThumbnail: false,
    },
    dependedItem: PostBackgroundItemNo.p42,
  },
  {
    itemId: PostBackgroundItemNo.p45,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Pattern,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Pattern05_04,
      thumbnailPrefix: null,
      textColor: '#000000',
      dotColor: '#f1c2f3',
      smallDotColor: null,
      hasThumbnail: false,
    },
    dependedItem: PostBackgroundItemNo.p42,
  },
  {
    itemId: PostBackgroundItemNo.p46,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Pattern,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Pattern05_05,
      thumbnailPrefix: null,
      textColor: '#000000',
      dotColor: '#c1b7f3',
      smallDotColor: null,
      hasThumbnail: false,
    },
    dependedItem: PostBackgroundItemNo.p42,
  },
  {
    itemId: PostBackgroundItemNo.p47,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Pattern,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Pattern05_06,
      thumbnailPrefix: null,
      textColor: '#000000',
      dotColor: '#f5e37f',
      smallDotColor: null,
      hasThumbnail: false,
    },
    dependedItem: PostBackgroundItemNo.p42,
  },
  {
    itemId: PostBackgroundItemNo.p48,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Pattern,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Pattern06_01,
      thumbnailPrefix: Post_Text_Bg_Pattern06_01_Th,
      textColor: '#ffffff',
      dotColor: '#243d8c',
      smallDotColor: '#62248c',
      hasThumbnail: true,
    },
    dependedItem: null,
  },
  {
    itemId: PostBackgroundItemNo.p49,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Pattern,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Pattern06_02,
      thumbnailPrefix: null,
      textColor: '#ffffff',
      dotColor: '#62248c',
      smallDotColor: null,
      hasThumbnail: false,
    },
    dependedItem: PostBackgroundItemNo.p48,
  },
  {
    itemId: PostBackgroundItemNo.p50,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Pattern,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Pattern06_03,
      thumbnailPrefix: null,
      textColor: '#ffffff',
      dotColor: '#000000',
      smallDotColor: null,
      hasThumbnail: false,
    },
    dependedItem: PostBackgroundItemNo.p48,
  },
  {
    itemId: PostBackgroundItemNo.p51,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Pattern,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Pattern06_04,
      thumbnailPrefix: null,
      textColor: '#000000',
      dotColor: '#ffffff',
      smallDotColor: null,
      hasThumbnail: false,
    },
    dependedItem: PostBackgroundItemNo.p48,
  },
  {
    itemId: PostBackgroundItemNo.p52,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Pattern,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Pattern07_01,
      thumbnailPrefix: Post_Text_Bg_Pattern07_01_Th,
      textColor: '#000000',
      dotColor: '#ffffff',
      smallDotColor: null,
      hasThumbnail: true,
    },
    dependedItem: null,
  },
  {
    itemId: PostBackgroundItemNo.p53,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Pattern,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Pattern08_01,
      thumbnailPrefix: Post_Text_Bg_Pattern08_01_Th,
      textColor: '#ffffff',
      dotColor: '#85755d',
      smallDotColor: '#5d857c',
      hasThumbnail: true,
    },
    dependedItem: null,
  },
  {
    itemId: PostBackgroundItemNo.p54,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Pattern,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Pattern08_02,
      thumbnailPrefix: null,
      textColor: '#ffffff',
      dotColor: '#5d857c',
      smallDotColor: null,
      hasThumbnail: false,
    },
    dependedItem: PostBackgroundItemNo.p53,
  },
  {
    itemId: PostBackgroundItemNo.p55,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Pattern,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Pattern08_03,
      thumbnailPrefix: null,
      textColor: '#ffffff',
      dotColor: '#7c5d85',
      smallDotColor: null,
      hasThumbnail: false,
    },
    dependedItem: PostBackgroundItemNo.p53,
  },
  {
    itemId: PostBackgroundItemNo.p56,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Pattern,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Pattern08_04,
      thumbnailPrefix: null,
      textColor: '#ffffff',
      dotColor: '#965656',
      smallDotColor: null,
      hasThumbnail: false,
    },
    dependedItem: PostBackgroundItemNo.p53,
  },
  {
    itemId: PostBackgroundItemNo.p57,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Pattern,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Pattern09_01,
      thumbnailPrefix: Post_Text_Bg_Pattern09_01_Th,
      textColor: '#ffffff',
      dotColor: '#000000',
      smallDotColor: '#ffffff',
      hasThumbnail: true,
    },
    dependedItem: null,
  },
  {
    itemId: PostBackgroundItemNo.p58,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Pattern,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Pattern09_02,
      thumbnailPrefix: null,
      textColor: '#000000',
      dotColor: '#ffffff',
      smallDotColor: null,
      hasThumbnail: false,
    },
    dependedItem: PostBackgroundItemNo.p57,
  },
  {
    itemId: PostBackgroundItemNo.p59,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Pattern,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Pattern10_01,
      thumbnailPrefix: Post_Text_Bg_Pattern10_01_Th,
      textColor: '#ffffff',
      dotColor: '#daa6ff',
      smallDotColor: '#a6cbff',
      hasThumbnail: true,
    },
    dependedItem: null,
  },
  {
    itemId: PostBackgroundItemNo.p60,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Pattern,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Pattern10_02,
      thumbnailPrefix: null,
      textColor: '#ffffff',
      dotColor: '#a6cbff',
      smallDotColor: null,
      hasThumbnail: false,
    },
    dependedItem: PostBackgroundItemNo.p59,
  },
  {
    itemId: PostBackgroundItemNo.p61,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Pattern,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Pattern10_03,
      thumbnailPrefix: null,
      textColor: '#ffffff',
      dotColor: '#ffa3a3',
      smallDotColor: null,
      hasThumbnail: false,
    },
    dependedItem: PostBackgroundItemNo.p59,
  },
  {
    itemId: PostBackgroundItemNo.p62,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Pattern,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Pattern10_04,
      thumbnailPrefix: null,
      textColor: '#000000',
      dotColor: '#d2f2a2',
      smallDotColor: null,
      hasThumbnail: false,
    },
    dependedItem: PostBackgroundItemNo.p59,
  },
  {
    itemId: PostBackgroundItemNo.p63,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Pattern,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Pattern10_05,
      thumbnailPrefix: null,
      textColor: '#000000',
      dotColor: '#ffe278',
      smallDotColor: null,
      hasThumbnail: false,
    },
    dependedItem: PostBackgroundItemNo.p59,
  },
  {
    itemId: PostBackgroundItemNo.p64,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Pattern,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Pattern11_01,
      thumbnailPrefix: Post_Text_Bg_Pattern11_01_Th,
      textColor: '#ffffff',
      dotColor: '#24a624',
      smallDotColor: '#0050a6',
      hasThumbnail: true,
    },
    dependedItem: null,
  },
  {
    itemId: PostBackgroundItemNo.p65,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Pattern,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Pattern11_02,
      thumbnailPrefix: null,
      textColor: '#ffffff',
      dotColor: '#0050a6',
      smallDotColor: null,
      hasThumbnail: false,
    },
    dependedItem: PostBackgroundItemNo.p64,
  },
  {
    itemId: PostBackgroundItemNo.p66,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Pattern,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Pattern11_03,
      thumbnailPrefix: null,
      textColor: '#ffffff',
      dotColor: '#5f24a6',
      smallDotColor: null,
      hasThumbnail: false,
    },
    dependedItem: PostBackgroundItemNo.p64,
  },
  {
    itemId: PostBackgroundItemNo.p67,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Pattern,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Pattern11_04,
      thumbnailPrefix: null,
      textColor: '#ffffff',
      dotColor: '#a624a4',
      smallDotColor: null,
      hasThumbnail: false,
    },
    dependedItem: PostBackgroundItemNo.p64,
  },
  {
    itemId: PostBackgroundItemNo.p68,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Pattern,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Pattern12_01,
      thumbnailPrefix: Post_Text_Bg_Pattern12_01_Th,
      textColor: '#000000',
      dotColor: '#ffffff',
      smallDotColor: '#000000',
      hasThumbnail: true,
    },
    dependedItem: null,
  },
  {
    itemId: PostBackgroundItemNo.p69,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Pattern,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Pattern12_02,
      thumbnailPrefix: null,
      textColor: '#ffffff',
      dotColor: '#000000',
      smallDotColor: null,
      hasThumbnail: false,
    },
    dependedItem: PostBackgroundItemNo.p68,
  },
  {
    itemId: PostBackgroundItemNo.p70,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Pattern,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Pattern13_01,
      thumbnailPrefix: Post_Text_Bg_Pattern13_01_Th,
      textColor: '#000000',
      dotColor: '#87c0c9',
      smallDotColor: '#7f9ac9',
      hasThumbnail: true,
    },
    dependedItem: null,
  },
  {
    itemId: PostBackgroundItemNo.p71,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Pattern,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Pattern13_02,
      thumbnailPrefix: null,
      textColor: '#000000',
      dotColor: '#7f9ac9',
      smallDotColor: null,
      hasThumbnail: false,
    },
    dependedItem: PostBackgroundItemNo.p70,
  },
  {
    itemId: PostBackgroundItemNo.p72,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Pattern,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Pattern13_03,
      thumbnailPrefix: null,
      textColor: '#000000',
      dotColor: '#a8c987',
      smallDotColor: null,
      hasThumbnail: false,
    },
    dependedItem: PostBackgroundItemNo.p70,
  },
  {
    itemId: PostBackgroundItemNo.p73,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Pattern,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Pattern13_04,
      thumbnailPrefix: null,
      textColor: '#000000',
      dotColor: '#a07fc9',
      smallDotColor: null,
      hasThumbnail: false,
    },
    dependedItem: PostBackgroundItemNo.p70,
  },
  {
    itemId: PostBackgroundItemNo.p74,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Pattern,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Pattern14_01,
      thumbnailPrefix: Post_Text_Bg_Pattern14_01_Th,
      textColor: '#ffffff',
      dotColor: '#301863',
      smallDotColor: '#14420f',
      hasThumbnail: true,
    },
    dependedItem: null,
  },
  {
    itemId: PostBackgroundItemNo.p75,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Pattern,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Pattern14_02,
      thumbnailPrefix: null,
      textColor: '#ffffff',
      dotColor: '#14420f',
      smallDotColor: null,
      hasThumbnail: false,
    },
    dependedItem: PostBackgroundItemNo.p74,
  },
  {
    itemId: PostBackgroundItemNo.p76,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Pattern,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Pattern14_03,
      thumbnailPrefix: null,
      textColor: '#ffffff',
      dotColor: '#1a2f6b',
      smallDotColor: null,
      hasThumbnail: false,
    },
    dependedItem: PostBackgroundItemNo.p74,
  },
  {
    itemId: PostBackgroundItemNo.p77,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Animal,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Animal01_01,
      thumbnailPrefix: Post_Text_Bg_Animal01_01_Th,
      textColor: '#000000',
      dotColor: '#fff8eb',
      smallDotColor: '#e5f5cd',
      hasThumbnail: true,
    },
    dependedItem: null,
  },
  {
    itemId: PostBackgroundItemNo.p78,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Animal,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Animal01_02,
      thumbnailPrefix: null,
      textColor: '#000000',
      dotColor: '#e5f5cd',
      smallDotColor: null,
      hasThumbnail: false,
    },
    dependedItem: PostBackgroundItemNo.p77,
  },
  {
    itemId: PostBackgroundItemNo.p79,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Animal,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Animal01_03,
      thumbnailPrefix: null,
      textColor: '#000000',
      dotColor: '#f7ebed',
      smallDotColor: null,
      hasThumbnail: false,
    },
    dependedItem: PostBackgroundItemNo.p77,
  },
  {
    itemId: PostBackgroundItemNo.p80,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Animal,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Animal01_04,
      thumbnailPrefix: null,
      textColor: '#000000',
      dotColor: '#daf0ee',
      smallDotColor: null,
      hasThumbnail: false,
    },
    dependedItem: PostBackgroundItemNo.p77,
  },
  {
    itemId: PostBackgroundItemNo.p81,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Animal,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Animal01_05,
      thumbnailPrefix: null,
      textColor: '#000000',
      dotColor: '#f0e9c5',
      smallDotColor: null,
      hasThumbnail: false,
    },
    dependedItem: PostBackgroundItemNo.p77,
  },
  {
    itemId: PostBackgroundItemNo.p82,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Animal,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Animal02_01,
      thumbnailPrefix: Post_Text_Bg_Animal02_01_Th,
      textColor: '#000000',
      dotColor: '#ffffff',
      smallDotColor: '#633b91',
      hasThumbnail: true,
    },
    dependedItem: null,
  },
  {
    itemId: PostBackgroundItemNo.p83,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Animal,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Animal02_02,
      thumbnailPrefix: null,
      textColor: '#ffffff',
      dotColor: '#633b91',
      smallDotColor: null,
      hasThumbnail: false,
    },
    dependedItem: PostBackgroundItemNo.p82,
  },
  {
    itemId: PostBackgroundItemNo.p84,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Animal,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Animal02_03,
      thumbnailPrefix: null,
      textColor: '#ffffff',
      dotColor: '#183761',
      smallDotColor: null,
      hasThumbnail: false,
    },
    dependedItem: PostBackgroundItemNo.p82,
  },
  {
    itemId: PostBackgroundItemNo.p85,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Animal,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Animal02_04,
      thumbnailPrefix: null,
      textColor: '#ffffff',
      dotColor: '#000000',
      smallDotColor: null,
      hasThumbnail: false,
    },
    dependedItem: PostBackgroundItemNo.p82,
  },
  {
    itemId: PostBackgroundItemNo.p86,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Animal,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Animal03_01,
      thumbnailPrefix: Post_Text_Bg_Animal03_01_Th,
      textColor: '#ffffff',
      dotColor: '#294566',
      smallDotColor: '#c48d28',
      hasThumbnail: true,
    },
    dependedItem: null,
  },
  {
    itemId: PostBackgroundItemNo.p87,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Animal,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Animal03_02,
      thumbnailPrefix: null,
      textColor: '#ffffff',
      dotColor: '#c48d28',
      smallDotColor: null,
      hasThumbnail: false,
    },
    dependedItem: PostBackgroundItemNo.p86,
  },
  {
    itemId: PostBackgroundItemNo.p88,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Animal,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Animal03_03,
      thumbnailPrefix: null,
      textColor: '#ffffff',
      dotColor: '#75395e',
      smallDotColor: null,
      hasThumbnail: false,
    },
    dependedItem: PostBackgroundItemNo.p86,
  },
  {
    itemId: PostBackgroundItemNo.p89,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Animal,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Animal04_01,
      thumbnailPrefix: Post_Text_Bg_Animal04_01_Th,
      textColor: '#000000',
      dotColor: '#8d8ada',
      smallDotColor: null,
      hasThumbnail: true,
    },
    dependedItem: null,
  },
  {
    itemId: PostBackgroundItemNo.p90,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Animal,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Animal05_01,
      thumbnailPrefix: Post_Text_Bg_Animal05_01_Th,
      textColor: '#ffffff',
      dotColor: '#2e4b54',
      smallDotColor: '#4d2e54',
      hasThumbnail: true,
    },
    dependedItem: null,
  },
  {
    itemId: PostBackgroundItemNo.p91,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Animal,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Animal05_02,
      thumbnailPrefix: null,
      textColor: '#ffffff',
      dotColor: '#4d2e54',
      smallDotColor: null,
      hasThumbnail: false,
    },
    dependedItem: PostBackgroundItemNo.p90,
  },
  {
    itemId: PostBackgroundItemNo.p92,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Animal,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Animal05_03,
      thumbnailPrefix: null,
      textColor: '#ffffff',
      dotColor: '#42542e',
      smallDotColor: null,
      hasThumbnail: false,
    },
    dependedItem: PostBackgroundItemNo.p90,
  },
  {
    itemId: PostBackgroundItemNo.p93,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Animal,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Animal05_04,
      thumbnailPrefix: null,
      textColor: '#ffffff',
      dotColor: '#404040',
      smallDotColor: null,
      hasThumbnail: false,
    },
    dependedItem: PostBackgroundItemNo.p90,
  },
  {
    itemId: PostBackgroundItemNo.p94,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Animal,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Animal06_01,
      thumbnailPrefix: Post_Text_Bg_Animal06_01_Th,
      textColor: '#000000',
      dotColor: '#47add6',
      smallDotColor: null,
      hasThumbnail: true,
    },
    dependedItem: null,
  },
  {
    itemId: PostBackgroundItemNo.p95,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Celebration,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Celebration01_01,
      thumbnailPrefix: Post_Text_Bg_Celebration01_01_Th,
      textColor: '#000000',
      dotColor: '#00c7f2',
      smallDotColor: '#ff8a05',
      hasThumbnail: true,
    },
    dependedItem: null,
  },
  {
    itemId: PostBackgroundItemNo.p96,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Celebration,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Celebration01_02,
      thumbnailPrefix: null,
      textColor: '#000000',
      dotColor: '#ff8a05',
      smallDotColor: null,
      hasThumbnail: false,
    },
    dependedItem: PostBackgroundItemNo.p95,
  },
  {
    itemId: PostBackgroundItemNo.p97,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Celebration,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Celebration01_03,
      thumbnailPrefix: null,
      textColor: '#ffffff',
      dotColor: '#001647',
      smallDotColor: null,
      hasThumbnail: false,
    },
    dependedItem: PostBackgroundItemNo.p95,
  },
  {
    itemId: PostBackgroundItemNo.p98,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Celebration,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Celebration02_01,
      thumbnailPrefix: Post_Text_Bg_Celebration02_01_Th,
      textColor: '#000000',
      dotColor: '#ffffff',
      smallDotColor: '#000000',
      hasThumbnail: true,
    },
    dependedItem: null,
  },
  {
    itemId: PostBackgroundItemNo.p99,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Celebration,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Celebration02_02,
      thumbnailPrefix: null,
      textColor: '#ffffff',
      dotColor: '#000000',
      smallDotColor: null,
      hasThumbnail: false,
    },
    dependedItem: PostBackgroundItemNo.p98,
  },
  {
    itemId: PostBackgroundItemNo.p100,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Celebration,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Celebration03_01,
      thumbnailPrefix: Post_Text_Bg_Celebration03_01_Th,
      textColor: '#ffffff',
      dotColor: '#11002b',
      smallDotColor: '#30001c',
      hasThumbnail: true,
    },
    dependedItem: null,
  },
  {
    itemId: PostBackgroundItemNo.p101,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Celebration,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Celebration03_02,
      thumbnailPrefix: null,
      textColor: '#ffffff',
      dotColor: '#30001c',
      smallDotColor: null,
      hasThumbnail: false,
    },
    dependedItem: PostBackgroundItemNo.p100,
  },
  {
    itemId: PostBackgroundItemNo.p102,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Celebration,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Celebration03_03,
      thumbnailPrefix: null,
      textColor: '#ffffff',
      dotColor: '#003011',
      smallDotColor: null,
      hasThumbnail: false,
    },
    dependedItem: PostBackgroundItemNo.p100,
  },
  {
    itemId: PostBackgroundItemNo.p103,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Celebration,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Celebration03_04,
      thumbnailPrefix: null,
      textColor: '#ffffff',
      dotColor: '#3d2f14',
      smallDotColor: null,
      hasThumbnail: false,
    },
    dependedItem: PostBackgroundItemNo.p100,
  },
  {
    itemId: PostBackgroundItemNo.p104,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Celebration,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Celebration04_01,
      thumbnailPrefix: Post_Text_Bg_Celebration04_01_Th,
      textColor: '#000000',
      dotColor: '#ff9de6',
      smallDotColor: '#c9ffd7',
      hasThumbnail: true,
    },
    dependedItem: null,
  },
  {
    itemId: PostBackgroundItemNo.p105,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Celebration,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Celebration04_02,
      thumbnailPrefix: null,
      textColor: '#000000',
      dotColor: '#c9ffd7',
      smallDotColor: null,
      hasThumbnail: false,
    },
    dependedItem: PostBackgroundItemNo.p104,
  },
  {
    itemId: PostBackgroundItemNo.p106,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Celebration,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Celebration05_01,
      thumbnailPrefix: Post_Text_Bg_Celebration05_01_Th,
      textColor: '#000000',
      dotColor: '#ffac00',
      smallDotColor: '#c08feb',
      hasThumbnail: true,
    },
    dependedItem: null,
  },
  {
    itemId: PostBackgroundItemNo.p107,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Celebration,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Celebration05_02,
      thumbnailPrefix: null,
      textColor: '#ffffff',
      dotColor: '#c08feb',
      smallDotColor: null,
      hasThumbnail: false,
    },
    dependedItem: PostBackgroundItemNo.p106,
  },
  {
    itemId: PostBackgroundItemNo.p108,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Celebration,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Celebration05_03,
      thumbnailPrefix: null,
      textColor: '#000000',
      dotColor: '#bbe864',
      smallDotColor: null,
      hasThumbnail: false,
    },
    dependedItem: PostBackgroundItemNo.p106,
  },
  {
    itemId: PostBackgroundItemNo.p109,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Celebration,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Celebration05_04,
      thumbnailPrefix: null,
      textColor: '#ffffff',
      dotColor: '#8f8f8f',
      smallDotColor: null,
      hasThumbnail: false,
    },
    dependedItem: PostBackgroundItemNo.p106,
  },
  {
    itemId: PostBackgroundItemNo.p110,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Celebration,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Celebration06_01,
      thumbnailPrefix: Post_Text_Bg_Celebration06_01_Th,
      textColor: '#000000',
      dotColor: '#ffa7a7',
      smallDotColor: '#a7b7ff',
      hasThumbnail: true,
    },
    dependedItem: null,
  },
  {
    itemId: PostBackgroundItemNo.p111,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Celebration,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Celebration06_02,
      thumbnailPrefix: null,
      textColor: '#000000',
      dotColor: '#a7b7ff',
      smallDotColor: null,
      hasThumbnail: false,
    },
    dependedItem: PostBackgroundItemNo.p110,
  },
  {
    itemId: PostBackgroundItemNo.p112,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Celebration,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Celebration06_03,
      thumbnailPrefix: null,
      textColor: '#000000',
      dotColor: '#dcffa7',
      smallDotColor: null,
      hasThumbnail: false,
    },
    dependedItem: PostBackgroundItemNo.p110,
  },
  {
    itemId: PostBackgroundItemNo.p113,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Celebration,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Celebration07_01,
      thumbnailPrefix: Post_Text_Bg_Celebration07_01_Th,
      textColor: '#000000',
      dotColor: '#1762a8',
      smallDotColor: '#17a8a8',
      hasThumbnail: true,
    },
    dependedItem: null,
  },
  {
    itemId: PostBackgroundItemNo.p114,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Celebration,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Celebration07_02,
      thumbnailPrefix: null,
      textColor: '#000000',
      dotColor: '#17a8a8',
      smallDotColor: null,
      hasThumbnail: false,
    },
    dependedItem: PostBackgroundItemNo.p113,
  },
  {
    itemId: PostBackgroundItemNo.p115,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Celebration,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Celebration07_03,
      thumbnailPrefix: null,
      textColor: '#000000',
      dotColor: '#a275c7',
      smallDotColor: null,
      hasThumbnail: false,
    },
    dependedItem: PostBackgroundItemNo.p113,
  },
  {
    itemId: PostBackgroundItemNo.p116,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Celebration,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Celebration08_01,
      thumbnailPrefix: Post_Text_Bg_Celebration08_01_Th,
      textColor: '#000000',
      dotColor: '#f5f5f5',
      smallDotColor: '#1762a8',
      hasThumbnail: true,
    },
    dependedItem: null,
  },
  {
    itemId: PostBackgroundItemNo.p117,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Celebration,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Celebration08_02,
      thumbnailPrefix: null,
      textColor: '#ffffff',
      dotColor: '#1762a8',
      smallDotColor: null,
      hasThumbnail: false,
    },
    dependedItem: PostBackgroundItemNo.p116,
  },
  {
    itemId: PostBackgroundItemNo.p118,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Celebration,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Celebration08_03,
      thumbnailPrefix: null,
      textColor: '#000000',
      dotColor: '#c7741c',
      smallDotColor: null,
      hasThumbnail: false,
    },
    dependedItem: PostBackgroundItemNo.p116,
  },
  {
    itemId: PostBackgroundItemNo.p119,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Celebration,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Celebration09_01,
      thumbnailPrefix: Post_Text_Bg_Celebration09_01_Th,
      textColor: '#000000',
      dotColor: '#fffffc',
      smallDotColor: '#f5dae1',
      hasThumbnail: true,
    },
    dependedItem: null,
  },
  {
    itemId: PostBackgroundItemNo.p120,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Celebration,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Celebration09_02,
      thumbnailPrefix: null,
      textColor: '#000000',
      dotColor: '#f5dae1',
      smallDotColor: null,
      hasThumbnail: false,
    },
    dependedItem: PostBackgroundItemNo.p119,
  },
  {
    itemId: PostBackgroundItemNo.p121,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Celebration,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Celebration09_03,
      thumbnailPrefix: null,
      textColor: '#ffffff',
      dotColor: '#3b1f0c',
      smallDotColor: null,
      hasThumbnail: false,
    },
    dependedItem: PostBackgroundItemNo.p119,
  },
  {
    itemId: PostBackgroundItemNo.p122,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Celebration,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Celebration09_04,
      thumbnailPrefix: null,
      textColor: '#ffffff',
      dotColor: '#000000',
      smallDotColor: null,
      hasThumbnail: false,
    },
    dependedItem: PostBackgroundItemNo.p119,
  },
  {
    itemId: PostBackgroundItemNo.p123,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Celebration,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Celebration10_01,
      thumbnailPrefix: Post_Text_Bg_Celebration10_01_Th,
      textColor: '#ffffff',
      dotColor: '#8c1515',
      smallDotColor: '#ffffff',
      hasThumbnail: true,
    },
    dependedItem: null,
  },
  {
    itemId: PostBackgroundItemNo.p124,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Celebration,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Celebration10_02,
      thumbnailPrefix: null,
      textColor: '#000000',
      dotColor: '#ffffff',
      smallDotColor: null,
      hasThumbnail: false,
    },
    dependedItem: PostBackgroundItemNo.p123,
  },
  {
    itemId: PostBackgroundItemNo.p125,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Celebration,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Celebration10_03,
      thumbnailPrefix: null,
      textColor: '#ffffff',
      dotColor: '#3e1c8c',
      smallDotColor: null,
      hasThumbnail: false,
    },
    dependedItem: PostBackgroundItemNo.p123,
  },
  {
    itemId: PostBackgroundItemNo.p126,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Celebration,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Celebration11_01,
      thumbnailPrefix: Post_Text_Bg_Celebration11_01_Th,
      textColor: '#000000',
      dotColor: '#ffe185',
      smallDotColor: '#9ed8ff',
      hasThumbnail: true,
    },
    dependedItem: null,
  },
  {
    itemId: PostBackgroundItemNo.p127,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Celebration,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Celebration11_02,
      thumbnailPrefix: null,
      textColor: '#000000',
      dotColor: '#9ed8ff',
      smallDotColor: null,
      hasThumbnail: false,
    },
    dependedItem: PostBackgroundItemNo.p126,
  },
  {
    itemId: PostBackgroundItemNo.p128,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Celebration,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Celebration11_03,
      thumbnailPrefix: null,
      textColor: '#000000',
      dotColor: '#b59eff',
      smallDotColor: null,
      hasThumbnail: false,
    },
    dependedItem: PostBackgroundItemNo.p126,
  },
  {
    itemId: PostBackgroundItemNo.p129,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Celebration,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Celebration11_04,
      thumbnailPrefix: null,
      textColor: '#000000',
      dotColor: '#9de665',
      smallDotColor: null,
      hasThumbnail: false,
    },
    dependedItem: PostBackgroundItemNo.p126,
  },
  {
    itemId: PostBackgroundItemNo.p130,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Fruit,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Fruit01_01,
      thumbnailPrefix: Post_Text_Bg_Fruit01_01_Th,
      textColor: '#ffffff',
      dotColor: '#ccb672',
      smallDotColor: '#7dbed9',
      hasThumbnail: true,
    },
    dependedItem: null,
  },
  {
    itemId: PostBackgroundItemNo.p131,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Fruit,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Fruit01_02,
      thumbnailPrefix: null,
      textColor: '#ffffff',
      dotColor: '#7dbed9',
      smallDotColor: null,
      hasThumbnail: false,
    },
    dependedItem: PostBackgroundItemNo.p130,
  },
  {
    itemId: PostBackgroundItemNo.p132,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Fruit,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Fruit01_03,
      thumbnailPrefix: null,
      textColor: '#ffffff',
      dotColor: '#857ec4',
      smallDotColor: null,
      hasThumbnail: false,
    },
    dependedItem: PostBackgroundItemNo.p130,
  },
  {
    itemId: PostBackgroundItemNo.p133,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Fruit,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Fruit01_04,
      thumbnailPrefix: null,
      textColor: '#ffffff',
      dotColor: '#bfd17d',
      smallDotColor: null,
      hasThumbnail: false,
    },
    dependedItem: PostBackgroundItemNo.p130,
  },
  {
    itemId: PostBackgroundItemNo.p134,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Fruit,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Fruit02_01,
      thumbnailPrefix: Post_Text_Bg_Fruit02_01_Th,
      textColor: '#ffffff',
      dotColor: '#d1b5b5',
      smallDotColor: '#b9cfac',
      hasThumbnail: true,
    },
    dependedItem: null,
  },
  {
    itemId: PostBackgroundItemNo.p135,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Fruit,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Fruit02_02,
      thumbnailPrefix: null,
      textColor: '#ffffff',
      dotColor: '#b9cfac',
      smallDotColor: null,
      hasThumbnail: false,
    },
    dependedItem: PostBackgroundItemNo.p134,
  },
  {
    itemId: PostBackgroundItemNo.p136,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Fruit,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Fruit02_03,
      thumbnailPrefix: null,
      textColor: '#ffffff',
      dotColor: '#b9c6d6',
      smallDotColor: null,
      hasThumbnail: false,
    },
    dependedItem: PostBackgroundItemNo.p134,
  },
  {
    itemId: PostBackgroundItemNo.p137,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Fruit,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Fruit02_04,
      thumbnailPrefix: null,
      textColor: '#ffffff',
      dotColor: '#d4c79c',
      smallDotColor: null,
      hasThumbnail: false,
    },
    dependedItem: PostBackgroundItemNo.p134,
  },
  {
    itemId: PostBackgroundItemNo.p138,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Fruit,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Fruit03_01,
      thumbnailPrefix: Post_Text_Bg_Fruit03_01_Th,
      textColor: '#ffffff',
      dotColor: '#001840',
      smallDotColor: '#ffffff',
      hasThumbnail: true,
    },
    dependedItem: null,
  },
  {
    itemId: PostBackgroundItemNo.p139,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Fruit,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Fruit03_02,
      thumbnailPrefix: null,
      textColor: '#000000',
      dotColor: '#ffffff',
      smallDotColor: null,
      hasThumbnail: false,
    },
    dependedItem: PostBackgroundItemNo.p138,
  },
  {
    itemId: PostBackgroundItemNo.p140,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Fruit,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Fruit03_03,
      thumbnailPrefix: null,
      textColor: '#000000',
      dotColor: '#ffd9db',
      smallDotColor: null,
      hasThumbnail: false,
    },
    dependedItem: PostBackgroundItemNo.p138,
  },
  {
    itemId: PostBackgroundItemNo.p141,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Fruit,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Fruit03_04,
      thumbnailPrefix: null,
      textColor: '#000000',
      dotColor: '#d4bade',
      smallDotColor: null,
      hasThumbnail: false,
    },
    dependedItem: PostBackgroundItemNo.p138,
  },
  {
    itemId: PostBackgroundItemNo.p142,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Fruit,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Fruit04_01,
      thumbnailPrefix: Post_Text_Bg_Fruit04_01_Th,
      textColor: '#ffffff',
      dotColor: '#8dc7bb',
      smallDotColor: '#e0cf8a',
      hasThumbnail: true,
    },
    dependedItem: null,
  },
  {
    itemId: PostBackgroundItemNo.p143,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Fruit,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Fruit04_02,
      thumbnailPrefix: null,
      textColor: '#ffffff',
      dotColor: '#e0cf8a',
      smallDotColor: null,
      hasThumbnail: false,
    },
    dependedItem: PostBackgroundItemNo.p142,
  },
  {
    itemId: PostBackgroundItemNo.p144,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Fruit,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Fruit04_03,
      thumbnailPrefix: null,
      textColor: '#ffffff',
      dotColor: '#89b4c7',
      smallDotColor: null,
      hasThumbnail: false,
    },
    dependedItem: PostBackgroundItemNo.p142,
  },
  {
    itemId: PostBackgroundItemNo.p145,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Fruit,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Fruit04_04,
      thumbnailPrefix: null,
      textColor: '#ffffff',
      dotColor: '#aca7c9',
      smallDotColor: null,
      hasThumbnail: false,
    },
    dependedItem: PostBackgroundItemNo.p142,
  },
  {
    itemId: PostBackgroundItemNo.p146,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Fruit,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Fruit05_01,
      thumbnailPrefix: Post_Text_Bg_Fruit05_01_Th,
      textColor: '#000000',
      dotColor: '#ffb5ca',
      smallDotColor: '#d4b5ff',
      hasThumbnail: true,
    },
    dependedItem: null,
  },
  {
    itemId: PostBackgroundItemNo.p147,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Fruit,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Fruit05_02,
      thumbnailPrefix: null,
      textColor: '#000000',
      dotColor: '#d4b5ff',
      smallDotColor: null,
      hasThumbnail: false,
    },
    dependedItem: PostBackgroundItemNo.p146,
  },
  {
    itemId: PostBackgroundItemNo.p148,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Fruit,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Fruit05_03,
      thumbnailPrefix: null,
      textColor: '#000000',
      dotColor: '#b5d0ff',
      smallDotColor: null,
      hasThumbnail: false,
    },
    dependedItem: PostBackgroundItemNo.p146,
  },
  {
    itemId: PostBackgroundItemNo.p149,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Fruit,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Fruit05_04,
      thumbnailPrefix: null,
      textColor: '#000000',
      dotColor: '#ff8f8f',
      smallDotColor: null,
      hasThumbnail: false,
    },
    dependedItem: PostBackgroundItemNo.p146,
  },
  {
    itemId: PostBackgroundItemNo.p150,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Fruit,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Fruit06_01,
      thumbnailPrefix: Post_Text_Bg_Fruit06_01_Th,
      textColor: '#000000',
      dotColor: '#6ec0eb',
      smallDotColor: '#72ccad',
      hasThumbnail: true,
    },
    dependedItem: null,
  },
  {
    itemId: PostBackgroundItemNo.p151,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Fruit,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Fruit06_02,
      thumbnailPrefix: null,
      textColor: '#000000',
      dotColor: '#72ccad',
      smallDotColor: null,
      hasThumbnail: false,
    },
    dependedItem: PostBackgroundItemNo.p150,
  },
  {
    itemId: PostBackgroundItemNo.p152,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Fruit,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Fruit06_03,
      thumbnailPrefix: null,
      textColor: '#000000',
      dotColor: '#f2db48',
      smallDotColor: null,
      hasThumbnail: false,
    },
    dependedItem: PostBackgroundItemNo.p150,
  },
  {
    itemId: PostBackgroundItemNo.p153,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Fruit,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Fruit06_04,
      thumbnailPrefix: null,
      textColor: '#000000',
      dotColor: '#c1d957',
      smallDotColor: null,
      hasThumbnail: false,
    },
    dependedItem: PostBackgroundItemNo.p150,
  },
  {
    itemId: PostBackgroundItemNo.p154,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Fruit,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Fruit07_01,
      thumbnailPrefix: Post_Text_Bg_Fruit07_01_Th,
      textColor: '#000000',
      dotColor: '#f5f5f2',
      smallDotColor: '#ede9f5',
      hasThumbnail: true,
    },
    dependedItem: null,
  },
  {
    itemId: PostBackgroundItemNo.p155,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Fruit,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Fruit07_02,
      thumbnailPrefix: null,
      textColor: '#000000',
      dotColor: '#ede9f5',
      smallDotColor: null,
      hasThumbnail: false,
    },
    dependedItem: PostBackgroundItemNo.p154,
  },
  {
    itemId: PostBackgroundItemNo.p156,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Fruit,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Fruit07_03,
      thumbnailPrefix: null,
      textColor: '#000000',
      dotColor: '#e6f5f3',
      smallDotColor: null,
      hasThumbnail: false,
    },
    dependedItem: PostBackgroundItemNo.p154,
  },
  {
    itemId: PostBackgroundItemNo.p157,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Fruit,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Fruit08_01,
      thumbnailPrefix: Post_Text_Bg_Fruit08_01_Th,
      textColor: '#000000',
      dotColor: '#cde5eb',
      smallDotColor: '#e6f5d8',
      hasThumbnail: true,
    },
    dependedItem: null,
  },
  {
    itemId: PostBackgroundItemNo.p158,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Fruit,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Fruit08_02,
      thumbnailPrefix: null,
      textColor: '#000000',
      dotColor: '#e6f5d8',
      smallDotColor: null,
      hasThumbnail: false,
    },
    dependedItem: PostBackgroundItemNo.p157,
  },
  {
    itemId: PostBackgroundItemNo.p159,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Fruit,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Fruit08_03,
      thumbnailPrefix: null,
      textColor: '#000000',
      dotColor: '#e6daf2',
      smallDotColor: null,
      hasThumbnail: false,
    },
    dependedItem: PostBackgroundItemNo.p157,
  },
  {
    itemId: PostBackgroundItemNo.p160,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Fruit,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Fruit08_04,
      thumbnailPrefix: null,
      textColor: '#000000',
      dotColor: '#fae3e3',
      smallDotColor: null,
      hasThumbnail: false,
    },
    dependedItem: PostBackgroundItemNo.p157,
  },
  {
    itemId: PostBackgroundItemNo.p161,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Funny,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Funny01_01,
      thumbnailPrefix: Post_Text_Bg_Funny01_01_Th,
      textColor: '#000000',
      dotColor: '#fecd00',
      smallDotColor: '#295d94',
      hasThumbnail: true,
    },
    dependedItem: null,
  },
  {
    itemId: PostBackgroundItemNo.p162,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Funny,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Funny01_02,
      thumbnailPrefix: null,
      textColor: '#ffffff',
      dotColor: '#295d94',
      smallDotColor: null,
      hasThumbnail: false,
    },
    dependedItem: PostBackgroundItemNo.p161,
  },
  {
    itemId: PostBackgroundItemNo.p163,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Funny,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Funny01_03,
      thumbnailPrefix: null,
      textColor: '#ffffff',
      dotColor: '#642569',
      smallDotColor: null,
      hasThumbnail: false,
    },
    dependedItem: PostBackgroundItemNo.p161,
  },
  {
    itemId: PostBackgroundItemNo.p164,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Funny,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Funny01_04,
      thumbnailPrefix: null,
      textColor: '#000000',
      dotColor: '#a6a6a6',
      smallDotColor: null,
      hasThumbnail: false,
    },
    dependedItem: PostBackgroundItemNo.p161,
  },
  {
    itemId: PostBackgroundItemNo.p165,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Funny,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Funny01_05,
      thumbnailPrefix: null,
      textColor: '#ffffff',
      dotColor: '#000000',
      smallDotColor: null,
      hasThumbnail: false,
    },
    dependedItem: PostBackgroundItemNo.p161,
  },
  {
    itemId: PostBackgroundItemNo.p166,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Funny,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Funny02_01,
      thumbnailPrefix: Post_Text_Bg_Funny02_01_Th,
      textColor: '#ffffff',
      dotColor: '#ffc2ca',
      smallDotColor: '#cca3ff',
      hasThumbnail: true,
    },
    dependedItem: null,
  },
  {
    itemId: PostBackgroundItemNo.p167,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Funny,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Funny02_02,
      thumbnailPrefix: null,
      textColor: '#ffffff',
      dotColor: '#cca3ff',
      smallDotColor: null,
      hasThumbnail: false,
    },
    dependedItem: PostBackgroundItemNo.p166,
  },
  {
    itemId: PostBackgroundItemNo.p168,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Funny,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Funny02_03,
      thumbnailPrefix: null,
      textColor: '#000000',
      dotColor: '#cdf5c3',
      smallDotColor: null,
      hasThumbnail: false,
    },
    dependedItem: PostBackgroundItemNo.p166,
  },
  {
    itemId: PostBackgroundItemNo.p169,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Funny,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Funny02_04,
      thumbnailPrefix: null,
      textColor: '#000000',
      dotColor: '#f3ed82',
      smallDotColor: null,
      hasThumbnail: false,
    },
    dependedItem: PostBackgroundItemNo.p166,
  },
  {
    itemId: PostBackgroundItemNo.p170,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Funny,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Funny03_01,
      thumbnailPrefix: Post_Text_Bg_Funny03_01_Th,
      textColor: '#000000',
      dotColor: '#ffd500',
      smallDotColor: '#56d7f5',
      hasThumbnail: true,
    },
    dependedItem: null,
  },
  {
    itemId: PostBackgroundItemNo.p171,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Funny,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Funny03_02,
      thumbnailPrefix: null,
      textColor: '#000000',
      dotColor: '#56d7f5',
      smallDotColor: null,
      hasThumbnail: false,
    },
    dependedItem: PostBackgroundItemNo.p170,
  },
  {
    itemId: PostBackgroundItemNo.p172,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Funny,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Funny03_03,
      thumbnailPrefix: null,
      textColor: '#000000',
      dotColor: '#f590de',
      smallDotColor: null,
      hasThumbnail: false,
    },
    dependedItem: PostBackgroundItemNo.p170,
  },
  {
    itemId: PostBackgroundItemNo.p173,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Funny,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Funny03_04,
      thumbnailPrefix: null,
      textColor: '#000000',
      dotColor: '#92de50',
      smallDotColor: null,
      hasThumbnail: false,
    },
    dependedItem: PostBackgroundItemNo.p170,
  },
  {
    itemId: PostBackgroundItemNo.p174,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Funny,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Funny04_01,
      thumbnailPrefix: Post_Text_Bg_Funny04_01_Th,
      textColor: '#000000',
      dotColor: '#8492b5',
      smallDotColor: '#ffffff',
      hasThumbnail: true,
    },
    dependedItem: null,
  },
  {
    itemId: PostBackgroundItemNo.p175,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Funny,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Funny04_02,
      thumbnailPrefix: null,
      textColor: '#000000',
      dotColor: '#ffffff',
      smallDotColor: null,
      hasThumbnail: false,
    },
    dependedItem: PostBackgroundItemNo.p174,
  },
  {
    itemId: PostBackgroundItemNo.p176,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Funny,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Funny05_01,
      thumbnailPrefix: Post_Text_Bg_Funny05_01_Th,
      textColor: '#ffffff',
      dotColor: '#f26dc4',
      smallDotColor: '#b66df2',
      hasThumbnail: true,
    },
    dependedItem: null,
  },
  {
    itemId: PostBackgroundItemNo.p177,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Funny,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Funny05_02,
      thumbnailPrefix: null,
      textColor: '#ffffff',
      dotColor: '#b66df2',
      smallDotColor: null,
      hasThumbnail: false,
    },
    dependedItem: PostBackgroundItemNo.p176,
  },
  {
    itemId: PostBackgroundItemNo.p178,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Funny,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Funny05_03,
      thumbnailPrefix: null,
      textColor: '#ffffff',
      dotColor: '#42d3e3',
      smallDotColor: null,
      hasThumbnail: false,
    },
    dependedItem: PostBackgroundItemNo.p176,
  },
  {
    itemId: PostBackgroundItemNo.p179,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Funny,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Funny05_04,
      thumbnailPrefix: null,
      textColor: '#000000',
      dotColor: '#ffffff',
      smallDotColor: null,
      hasThumbnail: false,
    },
    dependedItem: PostBackgroundItemNo.p176,
  },
  {
    itemId: PostBackgroundItemNo.p180,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Funny,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Funny06_01,
      thumbnailPrefix: Post_Text_Bg_Funny06_01_Th,
      textColor: '#ffffff',
      dotColor: '#875af5',
      smallDotColor: '#f26dc4',
      hasThumbnail: true,
    },
    dependedItem: null,
  },
  {
    itemId: PostBackgroundItemNo.p181,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Funny,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Funny06_02,
      thumbnailPrefix: null,
      textColor: '#ffffff',
      dotColor: '#f26dc4',
      smallDotColor: null,
      hasThumbnail: false,
    },
    dependedItem: PostBackgroundItemNo.p180,
  },
  {
    itemId: PostBackgroundItemNo.p182,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Funny,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Funny06_03,
      thumbnailPrefix: null,
      textColor: '#ffffff',
      dotColor: '#47d1a8',
      smallDotColor: null,
      hasThumbnail: false,
    },
    dependedItem: PostBackgroundItemNo.p180,
  },
  {
    itemId: PostBackgroundItemNo.p183,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Funny,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Funny06_04,
      thumbnailPrefix: null,
      textColor: '#000000',
      dotColor: '#ffffff',
      smallDotColor: null,
      hasThumbnail: false,
    },
    dependedItem: PostBackgroundItemNo.p180,
  },
  {
    itemId: PostBackgroundItemNo.p184,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Plant,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Plant01_01,
      thumbnailPrefix: Post_Text_Bg_Plant01_01_Th,
      textColor: '#000000',
      dotColor: '#5dd7f2',
      smallDotColor: '#53d9cb',
      hasThumbnail: true,
    },
    dependedItem: null,
  },
  {
    itemId: PostBackgroundItemNo.p185,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Plant,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Plant01_02,
      thumbnailPrefix: null,
      textColor: '#000000',
      dotColor: '#53d9cb',
      smallDotColor: null,
      hasThumbnail: false,
    },
    dependedItem: PostBackgroundItemNo.p184,
  },
  {
    itemId: PostBackgroundItemNo.p186,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Plant,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Plant01_03,
      thumbnailPrefix: null,
      textColor: '#000000',
      dotColor: '#f2c641',
      smallDotColor: null,
      hasThumbnail: false,
    },
    dependedItem: PostBackgroundItemNo.p184,
  },
  {
    itemId: PostBackgroundItemNo.p187,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Plant,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Plant01_04,
      thumbnailPrefix: null,
      textColor: '#ffffff',
      dotColor: '#0b1f54',
      smallDotColor: null,
      hasThumbnail: false,
    },
    dependedItem: PostBackgroundItemNo.p184,
  },
  {
    itemId: PostBackgroundItemNo.p188,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Plant,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Plant01_05,
      thumbnailPrefix: null,
      textColor: '#ffffff',
      dotColor: '#0d0d0f',
      smallDotColor: null,
      hasThumbnail: false,
    },
    dependedItem: PostBackgroundItemNo.p184,
  },
  {
    itemId: PostBackgroundItemNo.p189,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Plant,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Plant02_01,
      thumbnailPrefix: Post_Text_Bg_Plant02_01_Th,
      textColor: '#000000',
      dotColor: '#cab5ff',
      smallDotColor: '#afd6ff',
      hasThumbnail: true,
    },
    dependedItem: null,
  },
  {
    itemId: PostBackgroundItemNo.p190,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Plant,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Plant02_02,
      thumbnailPrefix: null,
      textColor: '#000000',
      dotColor: '#afd6ff',
      smallDotColor: null,
      hasThumbnail: false,
    },
    dependedItem: PostBackgroundItemNo.p189,
  },
  {
    itemId: PostBackgroundItemNo.p191,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Plant,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Plant02_03,
      thumbnailPrefix: null,
      textColor: '#000000',
      dotColor: '#ffafc4',
      smallDotColor: null,
      hasThumbnail: false,
    },
    dependedItem: PostBackgroundItemNo.p189,
  },
  {
    itemId: PostBackgroundItemNo.p192,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Plant,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Plant02_04,
      thumbnailPrefix: null,
      textColor: '#000000',
      dotColor: '#ffe684',
      smallDotColor: null,
      hasThumbnail: false,
    },
    dependedItem: PostBackgroundItemNo.p189,
  },
  {
    itemId: PostBackgroundItemNo.p193,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Plant,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Plant03_01,
      thumbnailPrefix: Post_Text_Bg_Plant03_01_Th,
      textColor: '#000000',
      dotColor: '#fffced',
      smallDotColor: '#fff7d1',
      hasThumbnail: true,
    },
    dependedItem: null,
  },
  {
    itemId: PostBackgroundItemNo.p194,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Plant,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Plant03_02,
      thumbnailPrefix: null,
      textColor: '#000000',
      dotColor: '#fff7d1',
      smallDotColor: null,
      hasThumbnail: false,
    },
    dependedItem: PostBackgroundItemNo.p193,
  },
  {
    itemId: PostBackgroundItemNo.p195,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Plant,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Plant03_03,
      thumbnailPrefix: null,
      textColor: '#000000',
      dotColor: '#d6e5ff',
      smallDotColor: null,
      hasThumbnail: false,
    },
    dependedItem: PostBackgroundItemNo.p193,
  },
  {
    itemId: PostBackgroundItemNo.p196,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Plant,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Plant03_04,
      thumbnailPrefix: null,
      textColor: '#000000',
      dotColor: '#ffe8f4',
      smallDotColor: null,
      hasThumbnail: false,
    },
    dependedItem: PostBackgroundItemNo.p193,
  },
  {
    itemId: PostBackgroundItemNo.p197,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Plant,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Plant04_01,
      thumbnailPrefix: Post_Text_Bg_Plant04_01_Th,
      textColor: '#000000',
      dotColor: '#16315e',
      smallDotColor: '#5e4327',
      hasThumbnail: true,
    },
    dependedItem: null,
  },
  {
    itemId: PostBackgroundItemNo.p198,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Plant,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Plant04_02,
      thumbnailPrefix: null,
      textColor: '#000000',
      dotColor: '#5e4327',
      smallDotColor: null,
      hasThumbnail: false,
    },
    dependedItem: PostBackgroundItemNo.p197,
  },
  {
    itemId: PostBackgroundItemNo.p199,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Plant,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Plant04_03,
      thumbnailPrefix: null,
      textColor: '#000000',
      dotColor: '#553a5e',
      smallDotColor: null,
      hasThumbnail: false,
    },
    dependedItem: PostBackgroundItemNo.p197,
  },
  {
    itemId: PostBackgroundItemNo.p200,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Plant,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Plant04_04,
      thumbnailPrefix: null,
      textColor: '#000000',
      dotColor: '#37525e',
      smallDotColor: null,
      hasThumbnail: false,
    },
    dependedItem: PostBackgroundItemNo.p197,
  },
  {
    itemId: PostBackgroundItemNo.p201,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Plant,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Plant05_01,
      thumbnailPrefix: Post_Text_Bg_Plant05_01_Th,
      textColor: '#ffffff',
      dotColor: '#4d312e',
      smallDotColor: '#462e4d',
      hasThumbnail: true,
    },
    dependedItem: null,
  },
  {
    itemId: PostBackgroundItemNo.p202,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Plant,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Plant05_02,
      thumbnailPrefix: null,
      textColor: '#ffffff',
      dotColor: '#462e4d',
      smallDotColor: null,
      hasThumbnail: false,
    },
    dependedItem: PostBackgroundItemNo.p201,
  },
  {
    itemId: PostBackgroundItemNo.p203,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Plant,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Plant05_03,
      thumbnailPrefix: null,
      textColor: '#ffffff',
      dotColor: '#591717',
      smallDotColor: null,
      hasThumbnail: false,
    },
    dependedItem: PostBackgroundItemNo.p201,
  },
  {
    itemId: PostBackgroundItemNo.p204,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Plant,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Plant05_04,
      thumbnailPrefix: null,
      textColor: '#ffffff',
      dotColor: '#1c314d',
      smallDotColor: null,
      hasThumbnail: false,
    },
    dependedItem: PostBackgroundItemNo.p201,
  },
  {
    itemId: PostBackgroundItemNo.p205,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Plant,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Plant06_01,
      thumbnailPrefix: Post_Text_Bg_Plant06_01_Th,
      textColor: '#ffffff',
      dotColor: '#003d47',
      smallDotColor: null,
      hasThumbnail: true,
    },
    dependedItem: null,
  },
  {
    itemId: PostBackgroundItemNo.p206,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Season,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Season01_01,
      thumbnailPrefix: Post_Text_Bg_Season01_01_Th,
      textColor: '#000000',
      dotColor: '#ffb5bf',
      smallDotColor: null,
      hasThumbnail: true,
    },
    dependedItem: null,
  },
  {
    itemId: PostBackgroundItemNo.p207,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Season,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Season02_01,
      thumbnailPrefix: Post_Text_Bg_Season02_01_Th,
      textColor: '#000000',
      dotColor: '#78baec',
      smallDotColor: null,
      hasThumbnail: true,
    },
    dependedItem: null,
  },
  {
    itemId: PostBackgroundItemNo.p208,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Season,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Season03_01,
      thumbnailPrefix: Post_Text_Bg_Season03_01_Th,
      textColor: '#000000',
      dotColor: '#f4b700',
      smallDotColor: null,
      hasThumbnail: true,
    },
    dependedItem: null,
  },
  {
    itemId: PostBackgroundItemNo.p209,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Season,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Season04_01,
      thumbnailPrefix: Post_Text_Bg_Season04_01_Th,
      textColor: '#000000',
      dotColor: '#ffffff',
      smallDotColor: null,
      hasThumbnail: true,
    },
    dependedItem: null,
  },
  {
    itemId: PostBackgroundItemNo.p210,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Texture,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Texture01_01,
      thumbnailPrefix: Post_Text_Bg_Texture01_01_Th,
      textColor: '#ffffff',
      dotColor: '#4c2321',
      smallDotColor: '#212f4c',
      hasThumbnail: true,
    },
    dependedItem: null,
  },
  {
    itemId: PostBackgroundItemNo.p211,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Texture,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Texture01_02,
      thumbnailPrefix: null,
      textColor: '#ffffff',
      dotColor: '#212f4c',
      smallDotColor: null,
      hasThumbnail: false,
    },
    dependedItem: PostBackgroundItemNo.p210,
  },
  {
    itemId: PostBackgroundItemNo.p212,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Texture,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Texture01_03,
      thumbnailPrefix: null,
      textColor: '#ffffff',
      dotColor: '#2d3a19',
      smallDotColor: null,
      hasThumbnail: false,
    },
    dependedItem: PostBackgroundItemNo.p210,
  },
  {
    itemId: PostBackgroundItemNo.p213,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Texture,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Texture01_04,
      thumbnailPrefix: null,
      textColor: '#ffffff',
      dotColor: '#353535',
      smallDotColor: null,
      hasThumbnail: false,
    },
    dependedItem: PostBackgroundItemNo.p210,
  },
  {
    itemId: PostBackgroundItemNo.p214,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Texture,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Texture02_01,
      thumbnailPrefix: Post_Text_Bg_Texture02_01_Th,
      textColor: '#ffffff',
      dotColor: '#5e6778',
      smallDotColor: '#50545c',
      hasThumbnail: true,
    },
    dependedItem: null,
  },
  {
    itemId: PostBackgroundItemNo.p215,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Texture,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Texture02_02,
      thumbnailPrefix: null,
      textColor: '#ffffff',
      dotColor: '#50545c',
      smallDotColor: null,
      hasThumbnail: false,
    },
    dependedItem: PostBackgroundItemNo.p214,
  },
  {
    itemId: PostBackgroundItemNo.p216,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Texture,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Texture03_01,
      thumbnailPrefix: Post_Text_Bg_Texture03_01_Th,
      textColor: '#000000',
      dotColor: '#d8a24c',
      smallDotColor: '#a0611c',
      hasThumbnail: true,
    },
    dependedItem: null,
  },
  {
    itemId: PostBackgroundItemNo.p217,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Texture,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Texture03_02,
      thumbnailPrefix: null,
      textColor: '#000000',
      dotColor: '#a0611c',
      smallDotColor: null,
      hasThumbnail: false,
    },
    dependedItem: PostBackgroundItemNo.p216,
  },
  {
    itemId: PostBackgroundItemNo.p218,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Texture,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Texture03_03,
      thumbnailPrefix: null,
      textColor: '#ffffff',
      dotColor: '#693631',
      smallDotColor: null,
      hasThumbnail: false,
    },
    dependedItem: PostBackgroundItemNo.p216,
  },
  {
    itemId: PostBackgroundItemNo.p219,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Texture,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Texture04_01,
      thumbnailPrefix: Post_Text_Bg_Texture04_01_Th,
      textColor: '#000000',
      dotColor: '#a8a8a8',
      smallDotColor: '#d6af47',
      hasThumbnail: true,
    },
    dependedItem: null,
  },
  {
    itemId: PostBackgroundItemNo.p220,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Texture,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Texture04_02,
      thumbnailPrefix: null,
      textColor: '#000000',
      dotColor: '#d6af47',
      smallDotColor: null,
      hasThumbnail: false,
    },
    dependedItem: PostBackgroundItemNo.p219,
  },
  {
    itemId: PostBackgroundItemNo.p221,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Texture,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Texture05_01,
      thumbnailPrefix: Post_Text_Bg_Texture05_01_Th,
      textColor: '#000000',
      dotColor: '#dcae52',
      smallDotColor: '#c77bc4',
      hasThumbnail: true,
    },
    dependedItem: null,
  },
  {
    itemId: PostBackgroundItemNo.p222,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Texture,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Texture05_02,
      thumbnailPrefix: null,
      textColor: '#ffffff',
      dotColor: '#c77bc4',
      smallDotColor: null,
      hasThumbnail: false,
    },
    dependedItem: PostBackgroundItemNo.p221,
  },
  {
    itemId: PostBackgroundItemNo.p223,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Texture,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Texture05_03,
      thumbnailPrefix: null,
      textColor: '#ffffff',
      dotColor: '#7673b8',
      smallDotColor: null,
      hasThumbnail: false,
    },
    dependedItem: PostBackgroundItemNo.p221,
  },
  {
    itemId: PostBackgroundItemNo.p224,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Texture,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Texture06_01,
      thumbnailPrefix: Post_Text_Bg_Texture06_01_Th,
      textColor: '#ffffff',
      dotColor: '#be5b00',
      smallDotColor: '#0056de',
      hasThumbnail: true,
    },
    dependedItem: null,
  },
  {
    itemId: PostBackgroundItemNo.p225,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Texture,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Texture06_02,
      thumbnailPrefix: null,
      textColor: '#ffffff',
      dotColor: '#0056de',
      smallDotColor: null,
      hasThumbnail: false,
    },
    dependedItem: PostBackgroundItemNo.p224,
  },
  {
    itemId: PostBackgroundItemNo.p226,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Texture,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Texture06_03,
      thumbnailPrefix: null,
      textColor: '#ffffff',
      dotColor: '#a300b8',
      smallDotColor: null,
      hasThumbnail: false,
    },
    dependedItem: PostBackgroundItemNo.p224,
  },
  {
    itemId: PostBackgroundItemNo.p227,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Texture,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Texture06_04,
      thumbnailPrefix: null,
      textColor: '#000000',
      dotColor: '#999999',
      smallDotColor: null,
      hasThumbnail: false,
    },
    dependedItem: PostBackgroundItemNo.p224,
  },
  {
    itemId: PostBackgroundItemNo.p228,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Texture,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Texture07_01,
      thumbnailPrefix: Post_Text_Bg_Texture07_01_Th,
      textColor: '#ffffff',
      dotColor: '#8cc63f',
      smallDotColor: null,
      hasThumbnail: true,
    },
    dependedItem: null,
  },
  {
    itemId: PostBackgroundItemNo.p229,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Texture,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Texture08_01,
      thumbnailPrefix: Post_Text_Bg_Texture08_01_Th,
      textColor: '#ffffff',
      dotColor: '#3b2414',
      smallDotColor: '#5c5c5c',
      hasThumbnail: true,
    },
    dependedItem: null,
  },
  {
    itemId: PostBackgroundItemNo.p230,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Texture,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Texture08_02,
      thumbnailPrefix: null,
      textColor: '#ffffff',
      dotColor: '#5c5c5c',
      smallDotColor: null,
      hasThumbnail: false,
    },
    dependedItem: PostBackgroundItemNo.p229,
  },
  {
    itemId: PostBackgroundItemNo.p231,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Texture,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Texture09_01,
      thumbnailPrefix: Post_Text_Bg_Texture09_01_Th,
      textColor: '#000000',
      dotColor: '#edc0d1',
      smallDotColor: '#c0cfed',
      hasThumbnail: true,
    },
    dependedItem: null,
  },
  {
    itemId: PostBackgroundItemNo.p232,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Texture,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Texture09_02,
      thumbnailPrefix: null,
      textColor: '#000000',
      dotColor: '#c0cfed',
      smallDotColor: null,
      hasThumbnail: false,
    },
    dependedItem: PostBackgroundItemNo.p231,
  },
  {
    itemId: PostBackgroundItemNo.p233,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Texture,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Texture09_03,
      thumbnailPrefix: null,
      textColor: '#000000',
      dotColor: '#dcedc0',
      smallDotColor: null,
      hasThumbnail: false,
    },
    dependedItem: PostBackgroundItemNo.p231,
  },
  {
    itemId: PostBackgroundItemNo.p234,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Texture,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Texture09_04,
      thumbnailPrefix: null,
      textColor: '#000000',
      dotColor: '#fdd29d',
      smallDotColor: null,
      hasThumbnail: false,
    },
    dependedItem: PostBackgroundItemNo.p231,
  },
  {
    itemId: PostBackgroundItemNo.p235,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Texture,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Texture10_01,
      thumbnailPrefix: Post_Text_Bg_Texture10_01_Th,
      textColor: '#ffffff',
      dotColor: '#00a4db',
      smallDotColor: '#00dbd3',
      hasThumbnail: true,
    },
    dependedItem: null,
  },
  {
    itemId: PostBackgroundItemNo.p236,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Texture,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Texture10_02,
      thumbnailPrefix: null,
      textColor: '#ffffff',
      dotColor: '#00dbd3',
      smallDotColor: null,
      hasThumbnail: false,
    },
    dependedItem: PostBackgroundItemNo.p235,
  },
  {
    itemId: PostBackgroundItemNo.p237,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Weather,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Weather01_01,
      thumbnailPrefix: Post_Text_Bg_Weather01_01_Th,
      textColor: '#000000',
      dotColor: '#17c3e8',
      smallDotColor: null,
      hasThumbnail: true,
    },
    dependedItem: null,
  },
  {
    itemId: PostBackgroundItemNo.p238,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Weather,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Weather02_01,
      thumbnailPrefix: Post_Text_Bg_Weather02_01_Th,
      textColor: '#ffffff',
      dotColor: '#010101',
      smallDotColor: '#003169',
      hasThumbnail: true,
    },
    dependedItem: null,
  },
  {
    itemId: PostBackgroundItemNo.p239,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Weather,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Weather02_02,
      thumbnailPrefix: null,
      textColor: '#ffffff',
      dotColor: '#003169',
      smallDotColor: null,
      hasThumbnail: false,
    },
    dependedItem: PostBackgroundItemNo.p238,
  },
  {
    itemId: PostBackgroundItemNo.p240,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Weather,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Weather02_03,
      thumbnailPrefix: null,
      textColor: '#ffffff',
      dotColor: '#186978',
      smallDotColor: null,
      hasThumbnail: false,
    },
    dependedItem: PostBackgroundItemNo.p238,
  },
  {
    itemId: PostBackgroundItemNo.p241,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Weather,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Weather02_04,
      thumbnailPrefix: null,
      textColor: '#ffffff',
      dotColor: '#580f6e',
      smallDotColor: null,
      hasThumbnail: false,
    },
    dependedItem: PostBackgroundItemNo.p238,
  },
  {
    itemId: PostBackgroundItemNo.p242,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Weather,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Weather03_01,
      thumbnailPrefix: Post_Text_Bg_Weather03_01_Th,
      textColor: '#000000',
      dotColor: '#ffffff',
      smallDotColor: '#ffcc00',
      hasThumbnail: true,
    },
    dependedItem: null,
  },
  {
    itemId: PostBackgroundItemNo.p243,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Weather,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Weather03_02,
      thumbnailPrefix: null,
      textColor: '#000000',
      dotColor: '#ffcc00',
      smallDotColor: null,
      hasThumbnail: false,
    },
    dependedItem: PostBackgroundItemNo.p242,
  },
  {
    itemId: PostBackgroundItemNo.p244,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Weather,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Weather03_03,
      thumbnailPrefix: null,
      textColor: '#000000',
      dotColor: '#4d9be3',
      smallDotColor: null,
      hasThumbnail: false,
    },
    dependedItem: PostBackgroundItemNo.p242,
  },
  {
    itemId: PostBackgroundItemNo.p245,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Weather,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Weather03_04,
      thumbnailPrefix: null,
      textColor: '#000000',
      dotColor: '#99ccd4',
      smallDotColor: null,
      hasThumbnail: false,
    },
    dependedItem: PostBackgroundItemNo.p242,
  },
  {
    itemId: PostBackgroundItemNo.p246,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Weather,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Weather04_01,
      thumbnailPrefix: Post_Text_Bg_Weather04_01_Th,
      textColor: '#000000',
      dotColor: '#ff9500',
      smallDotColor: '#ffd900',
      hasThumbnail: true,
    },
    dependedItem: null,
  },
  {
    itemId: PostBackgroundItemNo.p247,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Weather,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Weather04_02,
      thumbnailPrefix: null,
      textColor: '#000000',
      dotColor: '#ffd900',
      smallDotColor: null,
      hasThumbnail: false,
    },
    dependedItem: PostBackgroundItemNo.p246,
  },
  {
    itemId: PostBackgroundItemNo.p248,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Weather,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Weather04_03,
      thumbnailPrefix: null,
      textColor: '#000000',
      dotColor: '#0d4cde',
      smallDotColor: null,
      hasThumbnail: false,
    },
    dependedItem: PostBackgroundItemNo.p246,
  },
  {
    itemId: PostBackgroundItemNo.p249,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Weather,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Weather04_04,
      thumbnailPrefix: null,
      textColor: '#000000',
      dotColor: '#d92158',
      smallDotColor: null,
      hasThumbnail: false,
    },
    dependedItem: PostBackgroundItemNo.p246,
  },
  {
    itemId: PostBackgroundItemNo.p250,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Weather,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Weather05_01,
      thumbnailPrefix: Post_Text_Bg_Weather05_01_Th,
      textColor: '#ffffff',
      dotColor: '#271c36',
      smallDotColor: '#121f40',
      hasThumbnail: true,
    },
    dependedItem: null,
  },
  {
    itemId: PostBackgroundItemNo.p251,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Weather,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Weather05_02,
      thumbnailPrefix: null,
      textColor: '#ffffff',
      dotColor: '#121f40',
      smallDotColor: null,
      hasThumbnail: false,
    },
    dependedItem: PostBackgroundItemNo.p250,
  },
  {
    itemId: PostBackgroundItemNo.p252,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Weather,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Weather05_03,
      thumbnailPrefix: null,
      textColor: '#ffffff',
      dotColor: '#000000',
      smallDotColor: null,
      hasThumbnail: false,
    },
    dependedItem: PostBackgroundItemNo.p250,
  },
  {
    itemId: PostBackgroundItemNo.p253,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Weather,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Weather06_01,
      thumbnailPrefix: Post_Text_Bg_Weather06_01_Th,
      textColor: '#ffffff',
      dotColor: '#010101',
      smallDotColor: '#04002b',
      hasThumbnail: true,
    },
    dependedItem: null,
  },
  {
    itemId: PostBackgroundItemNo.p254,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Weather,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Weather06_02,
      thumbnailPrefix: null,
      textColor: '#ffffff',
      dotColor: '#04002b',
      smallDotColor: null,
      hasThumbnail: false,
    },
    dependedItem: PostBackgroundItemNo.p253,
  },
  {
    itemId: PostBackgroundItemNo.p255,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Weather,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Weather06_03,
      thumbnailPrefix: null,
      textColor: '#ffffff',
      dotColor: '#2b002a',
      smallDotColor: null,
      hasThumbnail: false,
    },
    dependedItem: PostBackgroundItemNo.p253,
  },
  {
    itemId: PostBackgroundItemNo.p256,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Weather,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Weather07_01,
      thumbnailPrefix: Post_Text_Bg_Weather07_01_Th,
      textColor: '#ffffff',
      dotColor: '#53ad00',
      smallDotColor: '#0093ad',
      hasThumbnail: true,
    },
    dependedItem: null,
  },
  {
    itemId: PostBackgroundItemNo.p257,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Weather,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Weather07_02,
      thumbnailPrefix: null,
      textColor: '#ffffff',
      dotColor: '#0093ad',
      smallDotColor: null,
      hasThumbnail: false,
    },
    dependedItem: PostBackgroundItemNo.p256,
  },
  {
    itemId: PostBackgroundItemNo.p258,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Weather,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Weather07_03,
      thumbnailPrefix: null,
      textColor: '#ffffff',
      dotColor: '#5c00ad',
      smallDotColor: null,
      hasThumbnail: false,
    },
    dependedItem: PostBackgroundItemNo.p256,
  },
  {
    itemId: PostBackgroundItemNo.p259,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Weather,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Weather07_04,
      thumbnailPrefix: null,
      textColor: '#ffffff',
      dotColor: '#ad5c00',
      smallDotColor: null,
      hasThumbnail: false,
    },
    dependedItem: PostBackgroundItemNo.p256,
  },
  {
    itemId: PostBackgroundItemNo.p260,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Weather,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Weather07_05,
      thumbnailPrefix: null,
      textColor: '#ffffff',
      dotColor: '#ad0000',
      smallDotColor: null,
      hasThumbnail: false,
    },
    dependedItem: PostBackgroundItemNo.p256,
  },
  {
    itemId: PostBackgroundItemNo.p261,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Weather,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Weather07_06,
      thumbnailPrefix: null,
      textColor: '#ffffff',
      dotColor: '#000f96',
      smallDotColor: null,
      hasThumbnail: false,
    },
    dependedItem: PostBackgroundItemNo.p256,
  },
  {
    itemId: PostBackgroundItemNo.p262,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Weather,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Weather08_01,
      thumbnailPrefix: Post_Text_Bg_Weather08_01_Th,
      textColor: '#000000',
      dotColor: '#8ea2ac',
      smallDotColor: '#8a92b5',
      hasThumbnail: true,
    },
    dependedItem: null,
  },
  {
    itemId: PostBackgroundItemNo.p263,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Weather,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Weather08_02,
      thumbnailPrefix: null,
      textColor: '#000000',
      dotColor: '#8a92b5',
      smallDotColor: null,
      hasThumbnail: false,
    },
    dependedItem: PostBackgroundItemNo.p262,
  },
  {
    itemId: PostBackgroundItemNo.p264,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Weather,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Weather08_03,
      thumbnailPrefix: null,
      textColor: '#000000',
      dotColor: '#85acc9',
      smallDotColor: null,
      hasThumbnail: false,
    },
    dependedItem: PostBackgroundItemNo.p262,
  },
  {
    itemId: PostBackgroundItemNo.p265,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Weather,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Weather08_04,
      thumbnailPrefix: null,
      textColor: '#000000',
      dotColor: '#828387',
      smallDotColor: null,
      hasThumbnail: false,
    },
    dependedItem: PostBackgroundItemNo.p262,
  },
  {
    itemId: PostBackgroundItemNo.p266,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Weather,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Weather09_01,
      thumbnailPrefix: Post_Text_Bg_Weather09_01_Th,
      textColor: '#000000',
      dotColor: '#17c3e8',
      smallDotColor: null,
      hasThumbnail: true,
    },
    dependedItem: null,
  },
  {
    itemId: PostBackgroundItemNo.p267,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Weather,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Weather10_01,
      thumbnailPrefix: Post_Text_Bg_Weather10_01_Th,
      textColor: '#000000',
      dotColor: '#97dbcd',
      smallDotColor: '#db97c4',
      hasThumbnail: true,
    },
    dependedItem: null,
  },
  {
    itemId: PostBackgroundItemNo.p268,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Weather,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Weather10_02,
      thumbnailPrefix: null,
      textColor: '#000000',
      dotColor: '#db97c4',
      smallDotColor: null,
      hasThumbnail: false,
    },
    dependedItem: PostBackgroundItemNo.p267,
  },
  {
    itemId: PostBackgroundItemNo.p269,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Weather,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Weather10_03,
      thumbnailPrefix: null,
      textColor: '#000000',
      dotColor: '#f0d06f',
      smallDotColor: null,
      hasThumbnail: false,
    },
    dependedItem: PostBackgroundItemNo.p267,
  },
  {
    itemId: PostBackgroundItemNo.p270,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Weather,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Weather10_04,
      thumbnailPrefix: null,
      textColor: '#000000',
      dotColor: '#7fb9e3',
      smallDotColor: null,
      hasThumbnail: false,
    },
    dependedItem: PostBackgroundItemNo.p267,
  },
  {
    itemId: PostBackgroundItemNo.p271,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Weather,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Weather11_01,
      thumbnailPrefix: Post_Text_Bg_Weather11_01_Th,
      textColor: '#ffffff',
      dotColor: '#232a33',
      smallDotColor: '#000000',
      hasThumbnail: true,
    },
    dependedItem: null,
  },
  {
    itemId: PostBackgroundItemNo.p272,
    category: 'posts',
    subcategory: 'backgrounds',
    type: 'postBackground',
    set: PostBackgroundSet.Weather,
    isVisible: true,
    visual: {
      filePrefix: Post_Text_Bg_Weather11_02,
      thumbnailPrefix: null,
      textColor: '#ffffff',
      dotColor: '#000000',
      smallDotColor: null,
      hasThumbnail: false,
    },
    dependedItem: PostBackgroundItemNo.p271,
  },
]);

// Convert the array to a map
const postBackgroundsMap = new Map(
  POST_BACKGROUNDS.map((item) => [item.itemId, item]),
);

// Function to get an item by itemId

export const getPostVisual = (
  itemId: PostBackgroundItemNo,
): PostVisual | undefined => {
  const item = postBackgroundsMap.get(itemId);
  return item?.visual;
};
